webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return textUtil; });
var textUtil = {
  methods: {
    initialCaps: function initialCaps(str) {
      var words = str.split(/[ ]+/).map(function (w) {
        var lc = w.toLowerCase();
        return lc.charAt(0).toUpperCase(0) + lc.slice(1);
      });
      return words.join(' ');
    },
    formatUSPhone: function formatUSPhone(str) {
      var chunks = str.match(/(\d\d\d)(\d\d\d)(\d\d\d\d)/);
      if (chunks !== null && chunks.length) {
        return '(' + chunks[1] + ') ' + chunks[2] + '-' + chunks[3];
      } else {
        return str;
      }
    },
    formatFriendlyDate: function formatFriendlyDate(str) {
      var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true };
      return new Date(str).toLocaleTimeString('en-US', options);
    },
    formatDollars: function formatDollars(str) {
      return '$' + Number(str).toFixed(2);
    }
  }
};

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return twosteau; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var twosteau = {
  data: function data() {
    return {
      persistedReservation: '',
      inProgress: false,
      host: 'https://k8s.hacksy-do.com/twosteau'
    };
  },
  methods: {
    requestReservation: function requestReservation(reservation, idToken) {
      console.log('idToken: ' + idToken);
      var v = this;
      var host = v.host;
      var path = '/reservations';

      $.ajax({
        url: host + path,
        type: 'POST',
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(reservation),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        beforeSend: function beforeSend(xhr) {
          v.inProgress = true;
          v.$emit('requestInProgress', v.inProgress);
        },
        error: function error(jqhxr, textStatus, errorThrown) {
          v.$emit('requestFailed', jqhxr.status);
        },
        success: function success(data) {
          v.persistedReservation = data;
          v.$emit('requestReceived', v.persistedReservation);
        },
        complete: function complete() {
          v.inProgress = false;
          v.$emit('requestInProgress', v.inProgress);
        }
      });
    },
    getReservations: function getReservations(idToken) {
      var v = this;
      var host = v.host;
      var path = '/reservations';

      $.ajax({
        url: host + path,
        type: 'GET',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        beforeSend: function beforeSend(xhr) {
          if (typeof idToken !== 'undefined') {
            xhr.setRequestHeader('Authorization', 'Bearer ' + idToken);
          }
          v.$emit('requestInProgress', true);
        },
        success: function success(data) {
          v.$emit('requestReceived', data);
        },
        complete: function complete() {
          v.inProgress = false;
          v.$emit('requestInProgress', false);
        }
      });
    },
    getSavedContacts: function getSavedContacts(idToken) {
      var v = this;
      var host = v.host;
      var path = '/contacts';

      $.ajax({
        url: host + path,
        type: 'GET',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        beforeSend: function beforeSend(xhr) {
          if (typeof idToken !== 'undefined') {
            xhr.setRequestHeader('Authorization', 'Bearer ' + idToken);
          }
          v.$emit('requestInProgress', true);
        },
        success: function success(data) {
          console.log(data);
          v.$emit('contactsReceived', data);
        },
        complete: function complete() {
          v.inProgress = false;
          v.$emit('requestInProgress', false);
        }
      });
    },
    getAccountCodes: function getAccountCodes(idToken) {
      var v = this;
      var host = v.host;
      var path = '/accountCodes';

      $.ajax({
        url: host + path,
        type: 'GET',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        beforeSend: function beforeSend(xhr) {
          v.$emit('requestInProgress', true);
        },
        success: function success(data) {
          console.log(data);
          v.$emit('accountCodesReceived', data);
        },
        complete: function complete() {
          v.inProgress = false;
          v.$emit('requestInProgress', false);
        }
      });
    },
    postAccountCode: function postAccountCode(accountCode, idToken) {
      var v = this;
      var host = v.host;
      var path = '/accountCodes';

      $.ajax({
        url: host + path,
        type: 'POST',
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(accountCode),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        beforeSend: function beforeSend(xhr) {
          v.inProgress = true;
          v.$emit('requestInProgress', v.inProgress);
        },
        success: function success(data) {
          v.persistedCode = data;
          v.$emit('accountCodePosted', v.persistedCode);
        },
        complete: function complete() {
          v.inProgress = false;
          v.$emit('requestInProgress', v.inProgress);
        }
      });
    },
    putAccountCode: function putAccountCode(accountCode, idToken) {
      var v = this;
      var host = v.host;
      var path = '/accountCode/' + accountCode.id;

      $.ajax({
        url: host + path,
        type: 'PUT',
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(accountCode),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        beforeSend: function beforeSend(xhr) {
          v.inProgress = true;
          v.$emit('requestInProgress', v.inProgress);
        },
        success: function success(data) {
          v.persistedCode = data;
          v.$emit('accountCodePut', v.persistedCode);
        },
        complete: function complete() {
          v.inProgress = false;
          v.$emit('requestInProgress', v.inProgress);
        }
      });
    },
    validateAccountCode: function validateAccountCode(accountCode) {
      var v = this;
      var host = v.host;
      var path = '/validateAccountCode/' + accountCode.id;

      $.ajax({
        url: host + path,
        type: 'GET',
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(accountCode),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        beforeSend: function beforeSend(xhr) {
          v.inProgress = true;
          v.$emit('requestInProgress', v.inProgress);
        },
        success: function success(data) {
          v.accountCodeValidation = data;
          v.$emit('accountCodeValidation', v.accountCodeValidation);
        },
        complete: function complete() {
          v.inProgress = false;
          v.$emit('requestInProgress', v.inProgress);
        }
      });
    }
  }
};

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth_AuthService__ = __webpack_require__(83);




var auth = new __WEBPACK_IMPORTED_MODULE_0__auth_AuthService__["a" /* default */]();

var login = auth.login,
    logout = auth.logout,
    authenticated = auth.authenticated,
    authNotifier = auth.authNotifier;


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    var _this = this;

    authNotifier.on('authChange', function (authState) {
      _this.authenticated = authState.authenticated;
    });
    return {
      auth: auth,
      authenticated: authenticated
    };
  },

  methods: {
    login: login,
    logout: logout,
    usersEnabled: function usersEnabled() {
      return false;
    }
  },
  mounted: function mounted() {
    $('.dropdown').dropdown();
  }
});

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Callback__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Contact__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Confirmation__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FlightInfo__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Reservations__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Payment__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AccountCodes__ = __webpack_require__(190);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: '/contact',
    name: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Contact__["a" /* default */]
  }, {
    path: '/confirmation',
    name: 'Confirmation',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Confirmation__["a" /* default */]
  }, {
    path: '/reservations',
    name: 'Reservations',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Reservations__["a" /* default */]
  }, {
    path: '/callback',
    name: 'Callback',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Callback__["a" /* default */]
  }, {
    path: '/flight_info',
    name: 'FlightInfo',
    component: __WEBPACK_IMPORTED_MODULE_6__components_FlightInfo__["a" /* default */]
  }, {
    path: '/payment',
    name: 'Payment',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Payment__["a" /* default */]
  }, {
    path: '/accountCodes',
    name: 'AccountCodes',
    component: __WEBPACK_IMPORTED_MODULE_9__components_AccountCodes__["a" /* default */]
  }, {
    path: '*',
    redirect: '/home'
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Summary_vue__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Locations_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DateTime_vue__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Contact_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Quote_vue__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Request_vue__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Confirmation_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FlightInfo_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_clients_twosteau_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_clients_lumberjacque_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_clients_carkclint_js__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__models_line_item_js__ = __webpack_require__(55);


















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_clients_twosteau_js__["a" /* twosteau */], __WEBPACK_IMPORTED_MODULE_11__mixins_clients_carkclint_js__["a" /* carkclint */], __WEBPACK_IMPORTED_MODULE_10__mixins_clients_lumberjacque_js__["a" /* lumberjacque */]],
  components: {
    Summary: __WEBPACK_IMPORTED_MODULE_1__Summary_vue__["a" /* default */], Locations: __WEBPACK_IMPORTED_MODULE_2__Locations_vue__["a" /* default */], DateTime: __WEBPACK_IMPORTED_MODULE_3__DateTime_vue__["a" /* default */], Contact: __WEBPACK_IMPORTED_MODULE_4__Contact_vue__["a" /* default */], Quote: __WEBPACK_IMPORTED_MODULE_5__Quote_vue__["a" /* default */], Request: __WEBPACK_IMPORTED_MODULE_6__Request_vue__["a" /* default */], Confirmation: __WEBPACK_IMPORTED_MODULE_7__Confirmation_vue__["a" /* default */], FlightInfo: __WEBPACK_IMPORTED_MODULE_8__FlightInfo_vue__["a" /* default */]
  },
  name: 'home',
  props: ['auth', 'authenticated'],
  data: function data() {
    return {
      reservation: {},
      locationsComplete: false,
      dateTimeComplete: false,
      contactComplete: false,
      quoteInProgress: false,
      quote: {},
      quotePrice: '',
      isArranger: false,
      apiReservation: {},
      tosAgreed: false,
      requestComplete: false,
      requestedReservation: {},
      confirmed: false,
      rideType: 0,
      additionalLineItems: [],
      paymentFunction: null,
      paymentInProgress: false,
      requestInProgress: false,
      errors: []
    };
  },
  methods: {
    completeReservation: function completeReservation() {
      this.requestInProgress = true;
      this.resolvePayment();
    },
    resolvePayment: function resolvePayment() {
      var _this = this;

      this.remoteLog('INFO', 'Home.vue', 'Attempting to resolve payment', { 'value': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.paymentFunction) });
      this.errors = [];
      var responseHandler;
      if (this.paymentFunction.type === 'cc') {
        responseHandler = function responseHandler(r) {
          _this.remoteLog('INFO', 'Home.vue', 'Resolving payment', { 'value': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(r) });
          if (r.messages.resultCode === 'Ok') {
            _this.remoteLog('INFO', 'Home.vue', 'Resolving payment successful', { 'value': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(r) });
            _this.apiReservation.payment = {
              identifier: r.opaqueData.dataValue,
              type: 'NONCE'
            };
          } else {
            _this.remoteLog('INFO', 'Home.vue', 'Resolving payment failed', { 'value': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(r) });
            _this.apiReservation.payment = null;
            _this.errors = ['Failed to validate payment information. Please try re-entering your information and submitting again.'];
          }
          if (_this.errors.length === 0) {
            _this.requestReservation(_this.apiReservation, _this.getIdToken());
            _this.requestInProgress = true;
          } else {
            $('#errorModal').modal('show');
            _this.requestInProgress = true;
          }
        };
        this.paymentFunction.function(responseHandler);
      } else {
        responseHandler = function responseHandler(r) {
          _this.apiReservation.payment = {
            identifier: r,
            type: 'ACCOUNT_CODE'
          };
          _this.requestReservation(_this.apiReservation, _this.getIdToken());
          _this.requestInProgress = true;
        };
        this.paymentFunction.function(responseHandler);
      }
    },
    checkIfComplete: function checkIfComplete() {
      this.requestComplete = this.tosAgreed && this.paymentFunction.function !== null;
    },
    getIdToken: function getIdToken() {
      return localStorage.id_token;
    },
    onQuoteInProgress: function onQuoteInProgress(value) {
      this.quoteInProgress = value;
    },
    onLocationsComplete: function onLocationsComplete(value) {
      if (value === true) {
        this.remoteLog('INFO', 'Home.vue', 'Locations complete', { 'value': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value) });
      }
      this.locationsComplete = value;
    },
    onDateTimeComplete: function onDateTimeComplete(value) {
      console.log('date val: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
      this.dateTimeComplete = value.complete;
      this.apiReservation.pickupDateTime = new Date(value.dateTime).toISOString();
    },
    onFlightInfoComplete: function onFlightInfoComplete(value) {
      console.log('complete!');
      this.dateTimeComplete = value.complete;
      this.apiReservation.pickupDateTime = value.dateTime;
      this.apiReservation.flightInfo = value.flightInfo;
    },
    onContactComplete: function onContactComplete(value) {
      this.contactComplete = value.complete;
      this.apiReservation.contacts = [value.contact];
    },
    onQuoteReceived: function onQuoteReceived(value) {
      this.$set(this.reservation, 'quote', value);
      this.quote = value;
    },
    onQuoteSelected: function onQuoteSelected(value) {
      this.$set(this.reservation, 'selectedQuote', value);
      this.apiReservation.quoteInfo = {
        totalFare: value.fares[0].totalFare,
        miles: this.reservation.quote.tripDetails.miles,
        minutes: this.reservation.quote.tripDetails.minutes,
        lineItems: value.fares[0].fareLineItems.map(function (i) {
          return { type: i.lineItemType, description: i.lineItemDescription, cost: i.lineItemCost };
        })
      };
      this.apiReservation.vehicleRequest = {
        vehicleType: value.vehCode.toUpperCase()
      };
      document.getElementById('quotes').scrollIntoView();
    },
    onLocationsSet: function onLocationsSet(value) {
      value.pickup.type = 'PICKUP';
      value.dropoff.type = 'DROPOFF';
      this.$set(this.reservation, 'pickup', value.pickup);
      this.$set(this.reservation, 'dropoff', value.dropoff);

      this.apiReservation.addresses = [this.reservation.pickup, this.reservation.dropoff];
      this.apiReservation.passengers = value.passengers;
      this.apiReservation.type = value.rideType;
    },
    onContactType: function onContactType(value) {
      this.isArranger = value === 'arranger';
    },
    onRequestUpdate: function onRequestUpdate(value) {
      this.apiReservation.vehicleRequest.acceptUpgrade = value.upgrades;
      this.tosAgreed = value.tosAgreed;
      this.paymentFunction = value.paymentFunction;
      this.apiReservation.clientNotes = value.clientNotes;
      this.checkIfComplete();
    },
    onRideTypeUpdated: function onRideTypeUpdated(value) {
      this.rideType = value;
      this.reset();
    },
    onMeetAndGreetUpdated: function onMeetAndGreetUpdated(value) {
      this.additionalLineItems = this.additionalLineItems.filter(function (i) {
        return i.lineItemType !== __WEBPACK_IMPORTED_MODULE_12__models_line_item_js__["a" /* default */].Types.MEET_AND_GREET;
      });
      if (value === true) {
        this.additionalLineItems.push(new __WEBPACK_IMPORTED_MODULE_12__models_line_item_js__["a" /* default */](15, 'Meet and Greet Service', __WEBPACK_IMPORTED_MODULE_12__models_line_item_js__["a" /* default */].Types.MEET_AND_GREET));
      }
    },
    showDateTime: function showDateTime() {
      return 'selectedQuote' in this.reservation && !this.confirmed;
    },
    showContactPrimary: function showContactPrimary() {
      return this.locationsComplete && this.dateTimeComplete && !this.confirmed;
    },
    showContactSecondary: function showContactSecondary() {
      return this.showContactPrimary() && this.isArranger && !this.confirmed;
    },
    showQuotes: function showQuotes() {
      return 'tripDetails' in this.quote && !this.quoteInProgress && !this.confirmed;
    },
    showLocations: function showLocations() {
      return !('selectedQuote' in this.reservation) && !this.confirmed;
    },
    showSummary: function showSummary() {
      return 'selectedQuote' in this.reservation && !this.confirmed;
    },
    showRequest: function showRequest() {
      return this.contactComplete && !this.confirmed;
    },
    showConfirmation: function showConfirmation() {
      return this.confirmed;
    },
    reset: function reset() {
      this.reservation = {};
      this.locationsComplete = false;
      this.dateTimeComplete = false;
      this.contactComplete = false;
      this.quoteInProgress = false;
      this.quote = {};
      this.quotePrice = '';
      this.isArranger = false;
      this.apiReservation = {};
      this.tosAgreed = false;
      this.requestComplete = false;
      this.requestedReservation = {};
      this.confirmed = false;

      this.additionalLineItems = [];
      this.paymentFunction = null;
      this.paymentInProgress = false;
      this.requestInProgress = false;
      this.errors = [];
    }
  },
  mounted: function mounted() {
    var v = this;
    this.$on('requestReceived', function (data) {
      v.requestInProgress = false;
      v.requestedReservation = data;
      v.confirmed = true;
    });
    this.$on('requestFailed', function (data) {
      v.errors = [];
      if (data === 402) {
        v.errors = [v.$t('home.errors.payment')];
      } else {
        v.errors = [v.$t('home.errors.other')];
      }
      v.requestInProgress = false;
      $('#errorModal').modal('show');
    });
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Summary',
  props: ['reservation'],
  methods: {
    getVehicleType: function getVehicleType() {
      if ('selectedQuote' in this.reservation) {
        return this.reservation.selectedQuote.vehicleName;
      } else {
        return '';
      }
    }
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_clients_shakespeare_js__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_ride_type_js__ = __webpack_require__(46);






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_clients_shakespeare_js__["a" /* shakespeare */]],
  name: 'Locations',
  props: {
    reservation: Object,
    quoteInProgress: Boolean
  },
  data: function data() {
    return {
      selected: '',
      rideType: '',
      pickupDisplay: '',
      pickup: {},
      dropoffDisplay: '',
      dropoff: {},
      passengers: '',
      errors: {},
      completeStatus: {},
      complete: false
    };
  },
  methods: {
    testFun: function testFun() {
      alert(this.selected);
    },
    validatePassengers: function validatePassengers() {
      this.passengers = $('#passengers').val();
      var passengerValidationKey = 'passengerValidation';
      if (this.passengers === '' || this.passengers < 99) {
        delete this.errors[passengerValidationKey];
      } else {
        var errrorText = this.$t('reservation.passengerCount.maxPassengerError');
        this.errors[passengerValidationKey] = errrorText;
      }
      this.checkForComplete();
    },
    checkForComplete: function checkForComplete() {
      if (this.pickup === '') {
        this.completeStatus.pickup = true;
      } else {
        this.completeStatus.pickup = false;
      }
      if (this.dropoff === '') {
        this.completeStatus.dropoff = true;
      } else {
        this.completeStatus.dropoff = false;
      }
      if (this.passengers === '') {
        this.completeStatus.passengers = true;
      } else {
        this.completeStatus.passengers = false;
      }
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.errors).length > 0) {
        this.completeStatus.errors = true;
      } else {
        this.completeStatus.errors = false;
      }
      var result = true;
      for (var o in this.completeStatus) {
        if (this.completeStatus[o]) result = false;
      }
      this.complete = result;
      this.$emit('locationsComplete', this.complete);
      if (this.complete) {
        this.$emit('locationsSet', { pickup: this.pickup, dropoff: this.dropoff, passengers: this.passengers, rideType: this.rideType });
        this.getQuote(this.pickup.formatted, this.dropoff.formatted, this.passengers);
      }
    },
    reactToType: function reactToType() {
      var seaTac = {
        formatted: '17801 International Blvd, Seattle, WA 98158',
        streetAddress: '17801 International Blvd',
        city: 'Seattle',
        state: 'WA',
        zip: '98158'
      };
      var seaTacLabel = 'Sea-Tac Airport';
      this.selected = $('#reservation-type').val();
      var rideTypeValidationKey = 'rideTypeValidation';
      delete this.errors[rideTypeValidationKey];
      switch (this.selected) {
        case '1':
          this.setPickup('', '');
          this.setDropoff(seaTacLabel, seaTac);
          this.rideType = __WEBPACK_IMPORTED_MODULE_2__models_ride_type_js__["a" /* default */].Types.AIRPORT_DROPOFF;
          break;
        case '2':
          this.setPickup(seaTacLabel, seaTac);
          this.setDropoff('', '');
          this.rideType = __WEBPACK_IMPORTED_MODULE_2__models_ride_type_js__["a" /* default */].Types.AIRPORT_PICKUP;
          break;
        case '3':
          this.setPickup('', '');
          this.setDropoff('', '');
          this.rideType = __WEBPACK_IMPORTED_MODULE_2__models_ride_type_js__["a" /* default */].Types.POINT_TO_POINT;
          break;
        case '4':
          this.setPickup('', '');
          this.setDropoff('', '');
          this.errors[rideTypeValidationKey] = this.$t('reservation.type.typeError');
          this.rideType = __WEBPACK_IMPORTED_MODULE_2__models_ride_type_js__["a" /* default */].Types.ERROR;
          this.showRideTypeModal();
          break;
      }
      console.log('type changed to:' + this.rideType);
      this.$emit('rideTypeUpdated', this.rideType);
      this.checkForComplete();
    },
    isTypeSet: function isTypeSet() {
      return this.selected !== '';
    },
    initStuff: function initStuff() {
      var v = this;
      var pickupInput = document.getElementById('pickup');
      var pickupAutocomplete = new google.maps.places.Autocomplete(pickupInput);

      var dropoffInput = document.getElementById('dropoff');
      var dropoffAutocomplete = new google.maps.places.Autocomplete(dropoffInput);

      var waBounds = {
        west: -123.9857102146,
        east: -120.4218054523,
        south: 46.4429925439,
        north: 48.9794468638
      };

      pickupAutocomplete.setOptions({ bounds: waBounds });
      dropoffAutocomplete.setOptions({ bounds: waBounds });

      pickupAutocomplete.addListener('place_changed', function () {
        var parsedAddress = v.parseAddress(this.getPlace().address_components);
        v.setPickup(parsedAddress['formatted'], parsedAddress);
      });

      dropoffAutocomplete.addListener('place_changed', function () {
        var parsedAddress = v.parseAddress(this.getPlace().address_components);
        v.setDropoff(parsedAddress['formatted'], parsedAddress);
      });
      this.checkForComplete();
    },
    parseAddress: function parseAddress(place) {
      var p = {};
      place.forEach(function (element) {
        p[element.types[0]] = element['short_name'];
      });
      p['formatted'] = p['street_number'] + ' ' + p['route'] + ', ' + p['locality'] + ', ' + p['administrative_area_level_1'] + ' ' + p['postal_code'];
      return {
        formatted: p['formatted'],
        streetAddress: p['street_number'] + ' ' + p['route'],
        city: p['locality'],
        state: p['administrative_area_level_1'],
        zip: p['postal_code']
      };
    },
    setPickup: function setPickup(display, actual) {
      this.pickupDisplay = display;
      this.pickup = actual;
      this.checkForComplete();
    },
    setDropoff: function setDropoff(display, actual) {
      this.dropoffDisplay = display;
      this.dropoff = actual;
      this.checkForComplete();
    },
    showRideTypeModal: function showRideTypeModal() {
      $('#unsupportedRideTypeModal').modal({
        closable: false,
        onDeny: function onDeny() {
          $('#reservation-type').dropdown('clear');
        },
        onApprove: function onApprove() {
          window.location = 'https://acestowncarservice.com/aces-hourly-request-form';
        }
      }).modal('show');
    }
  },
  mounted: function mounted() {
    var v = this;

    $(document).ready(function () {
      v.initStuff();
      $('.dropdown').dropdown({
        clearable: true
      });
    });
  }
});

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var RideType = function RideType() {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, RideType);
};

/* harmony default export */ __webpack_exports__["a"] = (RideType);


RideType.Types = {
  AIRPORT_DROPOFF: 'AIRPORTDROPOFF',
  AIRPORT_PICKUP: 'AIRPORTPICKUP',
  POINT_TO_POINT: 'POINTTOPOINT',
  ERROR: 'ERROR'
};

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__webpack_require__(48));

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DateTime',
  props: ['auth', 'authenticated'],
  data: function data() {
    return {
      date: '',
      time: '',
      dateTime: '',
      present: false,
      valid: false,
      complete: false
    };
  },
  methods: {
    showError: function showError() {
      return this.present && !this.valid;
    },
    checkForComplete: function checkForComplete() {
      this.present = false;
      this.valid = false;
      this.complete = false;

      if (this.date !== '' && this.time !== '') {
        this.present = true;
        var momentDateTime = this.getMomentDateTime();
        var now = this.$moment().add(4, 'hours');
        if (momentDateTime > now) {
          this.valid = true;
        }
      }

      this.complete = this.present && this.valid;
      this.$emit('dateTimeComplete', { complete: this.complete, dateTime: this.date + ' ' + this.time });
    },
    getMomentDateTime: function getMomentDateTime() {
      return this.$moment(this.date + ' ' + this.time);
    }
  },
  mounted: function mounted() {
    var v = this;
    var dateScript = function dateScript(currentDate, topDate) {
      $('#date').mobiscroll().calendar({
        onClose: function onClose(t, i) {
          v.date = t;
          v.checkForComplete();
        },
        mode: 'scroller',
        display: 'modal',
        minDate: currentDate,
        maxDate: topDate,
        dateOrder: 'M D dd yy',
        dateFormat: 'M dd, yy',
        timeFormat: 'h:mm A' });
      $('#time').mobiscroll().time({
        onClose: function onClose(t, i) {
          v.time = t;
          v.checkForComplete();
        },
        mode: 'clicker',
        display: 'modal',
        stepMinute: 5 });
    };

    $(function () {
      var currentDate = new Date();
      var topDate = new Date();
      currentDate.setHours(currentDate.getHours() - 24);
      topDate.setMonth(topDate.getMonth() + 11);
      dateScript(currentDate, topDate);
    });
  }
});

/***/ }),
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__(50);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc4f9706_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__(122);
function injectStyle (ssrContext) {
  __webpack_require__(119)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc4f9706_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_imask__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_imask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_imask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_clients_twosteau_js__ = __webpack_require__(21);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Contact',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_clients_twosteau_js__["a" /* twosteau */]],
  props: {
    passenger: Boolean,
    authenticated: Boolean
  },
  data: function data() {
    return {
      contact: {},
      complete: false,
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      smsEnabled: true,
      saveAddress: false,
      anotherMask: Number,
      phoneMask: {
        mask: '(000) 000-0000',
        lazy: true
      },
      savedContacts: [],
      selectedContact: 'new'
    };
  },
  components: {
    'imask-input': __WEBPACK_IMPORTED_MODULE_0_vue_imask__["IMaskComponent"]
  },
  methods: {
    checkEmail: function checkEmail(email) {
      var matches = email.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      return matches !== null && matches.length > 0;
    },
    checkForComplete: function checkForComplete() {
      console.log(this.phone.length);
      var values = [this.firstName !== '', this.lastName !== '', this.phone.length === 14, this.checkEmail(this.email)];
      var result = values.find(function (v) {
        return v === false;
      });
      console.log(values);
      return this.$emit('contactComplete', { complete: result !== false,
        contact: {
          firstName: this.firstName,
          lastName: this.lastName,
          company: '',
          email: this.email,
          phone: this.phone,
          smsEnabled: this.smsEnabled,
          saved: this.saveAddress,
          type: this.getType()
        }
      });
    },
    getType: function getType() {
      return 'PASSENGER';
    },
    getHeader: function getHeader() {
      var headers = {
        PASSENGER: 'Passenger Information',
        ARRANGER: 'Contact Information'
      };
      return headers[this.getType()];
    },
    phoneAccept: function phoneAccept(e) {
      this.phone = e.detail.unmaskedValue;
      this.checkForComplete();
    },
    getIdToken: function getIdToken() {
      return localStorage.id_token;
    },
    selectSaved: function selectSaved(e) {
      this.selectedContact = e;
      if (e.target.value !== 'new') {
        this.selectedContact = this.savedContacts[Number(e.target.value)];
        this.firstName = this.selectedContact.firstName;
        this.lastName = this.selectedContact.lastName;
        this.email = this.selectedContact.email;
        this.phone = this.selectedContact.phone;
        this.smsEnabled = this.selectedContact.snsEnabled;
      } else {
        this.selectedContact = 'new';
      }
      this.checkForComplete();
    }
  },
  mounted: function mounted() {
    $(document).ready(function () {
      $('.dropdown').dropdown();
      $('.ui.checkbox').checkbox();
    });
    this.getSavedContacts(this.getIdToken());
    this.$on('contactsReceived', function (data) {
      this.savedContacts = data;
    });
  }
});

/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_textUtil_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CostTable_vue__ = __webpack_require__(53);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Quote',
  props: {
    reservation: Object
  },
  components: { CostTable: __WEBPACK_IMPORTED_MODULE_1__CostTable_vue__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_textUtil_js__["a" /* textUtil */]],
  data: function data() {
    return {
      selected: null,
      date: '',
      time: '',
      dateTime: '',
      complete: false
    };
  },
  methods: {
    getImageUrl: function getImageUrl(vehType) {
      if (vehType === 'Executive Sedan') {
        return '/static/luxury-sedan.jpg';
      } else if (vehType === 'Executive SUV') {
        return '/static/luxury-suv.jpg';
      }
    },
    selectReservation: function selectReservation(value, index) {
      this.selected = index;
      this.$emit('selectReservation', value);
    },
    getAirportFareFromQuote: function getAirportFareFromQuote(quote) {
      return quote.fares.find(function (fare) {
        return fare.fareProfile === 'airport';
      });
    },
    getPointToPointFareFromQuote: function getPointToPointFareFromQuote(quote) {
      return quote.fares.find(function (fare) {
        return fare.fareProfile === 'pointtopoint';
      });
    },
    getBaseFareFromFare: function getBaseFareFromFare(fare) {
      return fare.fareLineItems.find(function (lineItem) {
        return lineItem.lineItemType === 'fare';
      });
    },
    showModal: function showModal(modalId) {
      $('#' + modalId).modal('show');
    }
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CostTable_vue__ = __webpack_require__(54);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c38af020_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CostTable_vue__ = __webpack_require__(128);
function injectStyle (ssrContext) {
  __webpack_require__(126)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CostTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c38af020_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CostTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_textUtil_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_line_item_js__ = __webpack_require__(55);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CostTable',
  props: {
    fareLineItems: Array,
    showFeeInfo: Boolean
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_textUtil_js__["a" /* textUtil */]],
  data: function data() {
    return {
      someVar: ''
    };
  },
  methods: {
    lineItems: function lineItems() {
      return this.fareLineItems.filter(function (lineItem) {
        return lineItem.lineItemType !== __WEBPACK_IMPORTED_MODULE_1__models_line_item_js__["a" /* default */].Types.TOTAL;
      });
    },
    total: function total() {
      var itemsToSum = this.lineItems();
      return itemsToSum.reduce(function (acc, item) {
        return acc + item.lineItemCost;
      }, 0);
    },
    serviceFeeInfo: function serviceFeeInfo() {
      return 'It is not necessary to tip your chauffeur. A 20% service charge is added to all reservations to fairly compensate all team members who contribute to your trip, including your chauffeur, reservationists, detailers, etc. If you would like to tip your chauffeur at the conclusion of service, this is at your discretion, but it is not expected.';
    },
    showServiceFeeModal: function showServiceFeeModal() {
      $('#serviceFeeInfoModal').modal('show');
    }
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var LineItem = function LineItem(lineItemCost, lineItemDescription, lineItemType) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LineItem);

  this.lineItemCost = lineItemCost;
  this.lineItemDescription = lineItemDescription;
  this.lineItemType = lineItemType;
};

/* harmony default export */ __webpack_exports__["a"] = (LineItem);


LineItem.Types = { MEET_AND_GREET: 'meet_and_greet', TOTAL: 'total' };

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_textUtil_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_ride_type_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_terms_of_service_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CostTable_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Payment_vue__ = __webpack_require__(57);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Request',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_textUtil_js__["a" /* textUtil */]],
  components: { CostTable: __WEBPACK_IMPORTED_MODULE_3__CostTable_vue__["a" /* default */], Payment: __WEBPACK_IMPORTED_MODULE_4__Payment_vue__["a" /* default */] },
  props: {
    reservation: Object,
    additionalLineItems: Object,
    rideType: Object
  },
  data: function data() {
    return {
      tosAgreed: false,
      upgrades: true,
      paymentFunction: null,
      clientNotes: ''
    };
  },
  methods: {
    onPaymentFunctionUpdated: function onPaymentFunctionUpdated(value) {
      this.paymentFunction = value.paymentFunction;
      this.onUpdate();
    },
    onUpdate: function onUpdate() {
      this.$emit('requestUpdated', { tosAgreed: this.tosAgreed, upgrades: this.upgrades, paymentFunction: this.paymentFunction, clientNotes: this.clientNotes });
    },
    lineItems: function lineItems() {
      var lineItems = [];
      if (this.rideType !== __WEBPACK_IMPORTED_MODULE_1__models_ride_type_js__["a" /* default */].Types.POINT_TO_POINT) {
        lineItems = this.reservation.selectedQuote.fares.filter(function (fare) {
          return fare.fareProfile === 'airport';
        })[0].fareLineItems;
      } else {
        lineItems = this.reservation.selectedQuote.fares.filter(function (fare) {
          return fare.fareProfile === 'pointtopoint';
        })[0].fareLineItems;
      }
      return lineItems.concat(this.additionalLineItems).filter(function (item) {
        return item.lineItemType !== 'total';
      });
    },
    total: function total() {
      var itemsToSum = this.lineItems();
      return itemsToSum.reduce(function (acc, item) {
        return acc + item.lineItemCost;
      }, 0);
    },
    termsOfService: function termsOfService() {
      return __WEBPACK_IMPORTED_MODULE_2__models_terms_of_service_js__["a" /* TermsOfService */].verbose;
    },
    showTermsOfService: function showTermsOfService() {
      var v = this;
      $('.ui.longer.modal').modal({
        closable: false,
        onDeny: function onDeny() {
          v.tosAgreed = false;
        },
        onApprove: function onApprove() {
          v.tosAgreed = true;
        }
      }).modal('show');
    }
  },
  mounted: function mounted() {
    $('.ui.checkbox').checkbox();
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__ = __webpack_require__(58);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00e561ca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__ = __webpack_require__(168);
function injectStyle (ssrContext) {
  __webpack_require__(134)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00e561ca_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(169)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_clients_anet_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_clients_lumberjacque_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_imask__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_imask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_imask__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Payment',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_clients_anet_js__["a" /* anet */], __WEBPACK_IMPORTED_MODULE_1__mixins_clients_lumberjacque_js__["a" /* lumberjacque */]],
  props: {
    reservation: Object
  },
  data: function data() {
    return {
      paymentType: 'cc',
      cardInfo: {
        cardNumber: '',
        cardCode: '',
        cardExpMonth: '',
        cardExpYear: ''
      },
      accountCode: '',
      paymentFunction: {
        type: null,
        function: null
      },
      complete: false
    };
  },
  components: {
    'imask-input': __WEBPACK_IMPORTED_MODULE_2_vue_imask__["IMaskComponent"]
  },
  methods: {
    someMethod: function someMethod() {
      return 0;
    },
    checkOnChange: function checkOnChange() {
      var _this = this;

      this.complete = this.isComplete();

      if (this.complete) {
        if (this.paymentType === 'cc') {
          this.paymentFunction.type = 'cc';
          this.paymentFunction.function = function (responseHandler) {
            return _this.verify(responseHandler);
          };
        } else {
          this.paymentFunction.type = 'ac';
          this.paymentFunction.function = function (responseHandler) {
            return responseHandler(_this.accountCode);
          };
        }
      } else {
        this.paymentFunction.type = null;
        this.paymentFunction.function = null;
      }
      this.$emit('paymentFunctionUpdated', { paymentFunction: this.paymentFunction });
    },
    isComplete: function isComplete() {
      var ccResults = [this.cardInfo.cardNumber === '', this.cardInfo.cardExpMonth === '', this.cardInfo.cardExpYear === '', this.cardInfo.cardCode === ''];
      var acResults = [this.accountCode === ''];
      var results = this.paymentType === 'cc' ? ccResults : acResults;
      var complete = !results.some(function (b) {
        return b;
      });
      this.remoteLog('INFO', 'Payment.vue', 'isComplete', { 'paymentType': this.paymentType, 'complete': complete });
      return complete;
    },
    verify: function verify(responseHandler) {
      var nonce = this.getNonce(this.cardInfo.cardNumber, this.cardInfo.cardExpMonth, this.cardInfo.cardExpYear, this.cardInfo.cardCode, responseHandler);
      this.remoteLog('INFO', 'Payment.vue', 'verify', { 'nonce': nonce });

      return nonce;
    }
  },
  mounted: function mounted() {
    $('select.dropdown').dropdown();
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return lumberjacque; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);


var lumberjacque = {
  data: function data() {
    return {
      someVal: ''
    };
  },
  methods: {
    remoteLog: function remoteLog(level, context, message, values) {
      values = values || new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();

      var host = 'https://k8s.hacksy-do.com/lumberjacque';
      var path = '/log';

      var payload = {
        context: context,
        logLevel: level,
        message: message,
        service: 'danno',
        values: values
      };

      $.ajax({
        url: host + path,
        type: 'POST',
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json'
      });
    }
  }
};

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Confirmation_vue__ = __webpack_require__(68);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a39ea6a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Confirmation_vue__ = __webpack_require__(174);
function injectStyle (ssrContext) {
  __webpack_require__(172)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Confirmation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a39ea6a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Confirmation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_textUtil_js__ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Confirmation',
  props: {
    reservation: Object
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_textUtil_js__["a" /* textUtil */]],
  data: function data() {
    return {
      confirmedReservation: {}
    };
  },
  methods: {
    getPaymentType: function getPaymentType() {
      var pType = this.reservation.payment.type;
      var fType;
      switch (pType) {
        case 'ACCOUNT_CODE':
          fType = 'Account Code';
          break;
        case 'CC':
          fType = 'Credit Card';
          break;
        default:
          fType = 'Other';
      }
      return fType;
    }
  },
  mounted: function mounted() {
    var v = this;
    if (typeof this.reservation === 'undefined') {
      v.confirmedReservation = JSON.parse('{"id":4,"refCode":"BFAHSBQC","contacts":[{"firstName":"Greg","lastName":"Mertzlufft","company":"","email":"greg@bikebloc.com","phone":"(206) 679*0919","snsEnabled":null,"saved":false,"type":"PASSENGER"}],"addresses":[{"streetAddress":"123 24th Ave","city":"Seattle","state":"WA","zip":"98122","type":"PICKUP"},{"streetAddress":"17801 International Blvd","city":"Seattle","state":"WA","zip":"98158","type":"DROPOFF"}],"type":"AIRPORTDROPOFF","pickupDateTime":"2019-02-19T03:00:00Z","vehicleRequest":{"vehicleType":"SEDAN","acceptUpgrade":true},"quoteInfo":{"totalFare":68.31,"miles":15.01,"minutes":24,"lineItems":[{"type":"fare","description":"Base Fare","cost":55.53},{"type":"fuelCharge","description":"Fuel Surcharge","cost":1.67},{"type":"serviceCharge","description":"Service Charge","cost":11.11},{"type":"total","description":"Total","cost":68.31}]}}');
    } else {
      v.confirmedReservation = this.reservation;
    }
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlightInfo_vue__ = __webpack_require__(70);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e57b5970_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlightInfo_vue__ = __webpack_require__(177);
function injectStyle (ssrContext) {
  __webpack_require__(175)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlightInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e57b5970_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlightInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(178)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_clients_carkclint_js__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_textUtil_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(18);





__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__webpack_require__(48));

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FlightInfo',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_clients_carkclint_js__["a" /* carkclint */], __WEBPACK_IMPORTED_MODULE_1__mixins_textUtil_js__["a" /* textUtil */]],
  data: function data() {
    return {
      airline: '',
      flightNo: '',
      flightDate: '',
      flightInfoInProgress: false,
      flightInfoCompleteValue: false,
      flightInfo: {},
      formattedFlightData: {},
      meetAndGreet: false,
      checkedBaggage: false,
      meetAndGreetSign: '',
      valid: true
    };
  },
  methods: {
    verify: function verify() {
      this.verifyFlight(this.flightDate, this.airline, this.flightNo, 'SEA');
    },
    selectAirline: function selectAirline(e) {
      this.airline = e.target.value;
      this.reset();
    },
    readyToVerify: function readyToVerify() {
      return this.airline !== '' && this.flightNo !== '' && this.flightDate !== '';
    },
    flightInfoComplete: function flightInfoComplete() {
      if ('status' in this.flightInfo && this.flightInfo.status === 'Scheduled') {
        this.formattedFlightData.airline = this.airline;
        this.formattedFlightData.flightNumber = this.flightNo;
        this.formattedFlightData.arrivalAirport = this.flightInfo.destination;
        this.formattedFlightData.departureAirport = this.flightInfo.origin;
        this.formattedFlightData.checkedBaggage = true;

        var momentDateTime = this.momentFromString(this.flightInfo.scheduledArrival);
        this.formattedFlightData.scheduledArrivalDate = this.stringFromMoment(momentDateTime);

        this.valid = false;
        var now = this.$moment().add(4, 'hours');
        if (momentDateTime > now) {
          this.valid = true;
        }

        this.flightInfoCompleteValue = true;

        this.$emit('flightInfoComplete', { complete: this.valid, dateTime: this.momentFromString(this.flightInfo.scheduledArrival).format(), flightInfo: this.formattedFlightData });

        return true;
      } else {
        this.flightInfoCompleteValue = false;
        return false;
      }
    },
    momentFromString: function momentFromString(str) {
      var m = this.$moment(str, 'YYYYMMDDTHHmmss');
      console.log('moment: ' + m.format() + ' from ' + str);
      return m;
    },
    stringFromMoment: function stringFromMoment(m) {
      return m.format('YYYY-MM-DDTHH:mm:ss');
    },
    flightInfoError: function flightInfoError() {
      if ('status' in this.flightInfo && this.flightInfo.status !== 'Scheduled') {
        return true;
      }
      return false;
    },
    serviceInfoMessage: function serviceInfoMessage() {
      if (this.meetAndGreet) {
        return this.$t('flight.serviceInfo.meetAndGreet');
      } else {
        return this.$t('flight.serviceInfo.standard');
      }
    },
    reactToMeetAndGreet: function reactToMeetAndGreet() {
      this.$emit('meetAndGreetUpdated', this.meetAndGreet);
    },
    reset: function reset() {
      this.flightInfo = {};
    }
  },
  mounted: function mounted() {
    var v = this;

    v.$on('flightConfirmationReceived', function (e) {
      this.flightInfo = e;
      this.flightInfoComplete();
    });

    v.$on('flightConfirmationInProgress', function (p) {
      this.flightInfoInProgress = p;
    });

    var dateScript = function dateScript(currentDate, topDate) {
      $('#date').mobiscroll().calendar({
        onClose: function onClose(t, i) {
          v.flightDate = t;
        },
        mode: 'scroller',
        display: 'modal',
        minDate: currentDate,
        maxDate: topDate,
        dateOrder: 'M D dd yy' });
    };

    $(function () {
      var currentDate = new Date();
      var topDate = new Date();
      currentDate.setHours(currentDate.getHours() - 24);
      topDate.setMonth(topDate.getMonth() + 11);
      dateScript(currentDate, topDate);
    });

    $('.dropdown').dropdown();
    $('.checkbox').checkbox();
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return carkclint; });

var carkclint = {
  data: function data() {
    return {
      flightInfo: '',
      inProgress: false
    };
  },
  methods: {
    formatMonthOrDay: function formatMonthOrDay(num) {
      var str = String(num);
      if (str.length === 1) {
        return '0' + str;
      } else {
        return str;
      }
    },
    verifyFlight: function verifyFlight(date, airline, flightNumber, airport) {
      var v = this;

      var dateObj = new Date(date);
      var formattedDate = encodeURIComponent('' + dateObj.getFullYear() + this.formatMonthOrDay(dateObj.getMonth() + 1) + this.formatMonthOrDay(dateObj.getDate()));
      var formattedAirline = encodeURIComponent(airline);
      var formattedFlightNumber = encodeURIComponent(flightNumber);
      var formattedAirport = encodeURIComponent(airport);

      var host = 'https://k8s.hacksy-do.com/carkclint';
      var path = '/v1/flight?airline=' + formattedAirline + '&date=' + formattedDate + '&flightno=' + formattedFlightNumber + '&airport=' + formattedAirport;

      $.ajax({
        url: host + path,
        type: 'GET',
        dataType: 'json',
        headers: {
          Accept: 'application/json; charset=utf-8',
          'Content-Type': 'application/json; charset=utf-8'
        },
        beforeSend: function beforeSend(xhr) {
          v.inProgress = true;
          v.$emit('flightConfirmationInProgress', v.inProgress);
        },
        error: function error(e) {
          v.$emit('flightConfirmationReceived', { status: 'ERROR' });
        },
        success: function success(data) {
          console.log(data);
          v.quote = data;
          v.$emit('flightConfirmationReceived', v.quote);
        },
        complete: function complete() {
          v.inProgress = false;
          v.$emit('flightConfirmationInProgress', v.inProgress);
        }
      });
    }
  }
};

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'callback',
  props: ['auth'],
  data: function data() {
    this.auth.handleAuthentication();
    return {};
  }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_clients_twosteau_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_textUtil_js__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Reservations',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_clients_twosteau_js__["a" /* twosteau */], __WEBPACK_IMPORTED_MODULE_1__mixins_textUtil_js__["a" /* textUtil */]],
  data: function data() {
    return {
      reservations: {}
    };
  },
  methods: {
    getIdToken: function getIdToken() {
      return localStorage.id_token;
    }
  },
  mounted: function mounted() {
    this.getReservations(this.getIdToken());
    this.$on('requestReceived', function (data) {
      this.reservations = data;
    });
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_clients_twosteau_js__ = __webpack_require__(21);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AccountCodes',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_clients_twosteau_js__["a" /* twosteau */]],
  data: function data() {
    return {
      accountCodes: [],
      newCodeName: ''
    };
  },
  methods: {
    getIdToken: function getIdToken() {
      return localStorage.id_token;
    },
    getCodes: function getCodes() {
      this.accountCodes = this.getAccountCodes(this.getIdToken());
      this.$on('accountCodesReceived', function (data) {
        this.accountCodes = data;
      });
    },
    createNewCode: function createNewCode() {
      var v = this;
      var newCode = { name: v.newCodeName, status: 'ACTIVE' };
      v.postAccountCode(newCode, v.getIdToken);
      this.$on('accountCodePosted', function (data) {
        v.getCodes();
      });
      v.newCodeName = '';
    },
    toggleCode: function toggleCode(index) {
      var v = this;
      var selectedCode = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, v.accountCodes[index]);
      if (selectedCode.status === 'ACTIVE') {
        selectedCode.status = 'INACTIVE';
      } else {
        selectedCode.status = 'ACTIVE';
      }
      v.putAccountCode(selectedCode, v.getIdToken);
      this.$on('accountCodePut', function (data) {
        v.getCodes();
      });
    }
  },
  mounted: function mounted() {
    this.getCodes();
  }
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_i18n__ = __webpack_require__(201);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_i18n__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var messages = {
  en: {
    message: {
      test: 'hello world'
    }
  }
};

var i18n = new __WEBPACK_IMPORTED_MODULE_3_vue_i18n__["a" /* default */]({
  locale: 'en',
  messages: messages
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  i18n: i18n,
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});

/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(35);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bcf9a32_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(200);
function injectStyle (ssrContext) {
  __webpack_require__(80)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bcf9a32_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(81);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2bf44e3d", content, true, {});

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports
exports.push([module.i, "@import url(https://cdnjs.cloudflare.com/ajax/libs/semantic-ui/2.3.3/semantic.min.css);", ""]);

// module
exports.push([module.i, ".hidden.menu{display:none}.masthead.segment{min-height:700px;padding:1em 0}.masthead .logo.item img{margin-right:1em}.masthead .ui.menu .ui.button{margin-left:.5em}.masthead h1.ui.header{margin-top:3em;margin-bottom:0;font-size:4em;font-weight:400}.masthead h2{font-size:1.7em;font-weight:400}.ui.vertical.stripe{padding:8em 0}.ui.vertical.stripe h3{font-size:2em}.ui.vertical.stripe .button+h3,.ui.vertical.stripe p+h3{margin-top:3em}.ui.vertical.stripe .floated.image{clear:both}.ui.vertical.stripe p{font-size:1.33em}.ui.vertical.stripe .horizontal.divider{margin:3em 0}.quote.stripe.segment{padding:0}.quote.stripe.segment .grid .column{padding-top:5em;padding-bottom:5em}.footer.segment{padding:5em 0}.secondary.pointing.menu .toc.item{display:none}@media only screen and (max-width:700px){.ui.fixed.menu{display:none!important}.secondary.pointing.menu .item,.secondary.pointing.menu .menu{display:none}.secondary.pointing.menu .toc.item{display:block}.masthead.segment{min-height:350px}.masthead h1.ui.header{font-size:2em;margin-top:1.5em}.masthead h2{margin-top:.5em;font-size:1.5em}}", ""]);

// exports


/***/ }),
/* 82 */,
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_auth0_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth0_variables__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_eventemitter3__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_eventemitter3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_eventemitter3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(39);








var AuthService = function () {
  function AuthService() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AuthService);

    this.authenticated = this.isAuthenticated();
    this.authNotifier = new __WEBPACK_IMPORTED_MODULE_5_eventemitter3___default.a();
    this.auth0 = new __WEBPACK_IMPORTED_MODULE_3_auth0_js__["a" /* default */].WebAuth({
      domain: __WEBPACK_IMPORTED_MODULE_4__auth0_variables__["a" /* AUTH_CONFIG */].domain,
      clientID: __WEBPACK_IMPORTED_MODULE_4__auth0_variables__["a" /* AUTH_CONFIG */].clientId,
      redirectUri: __WEBPACK_IMPORTED_MODULE_4__auth0_variables__["a" /* AUTH_CONFIG */].callbackUrl,
      responseType: 'token id_token',
      scope: 'openid'
    });

    this.login = this.login.bind(this);
    this.setSession = this.setSession.bind(this);
    this.logout = this.logout.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AuthService, [{
    key: 'login',
    value: function login() {
      this.auth0.authorize();
    }
  }, {
    key: 'handleAuthentication',
    value: function handleAuthentication() {
      var _this = this;

      var match = RegExp('[#&]' + 'id_token' + '=([^&]*)').exec(window.location.hash);
      console.log(match && match[1].replace(/\+/g, ' '));

      this.auth0.parseHash(function (err, authResult) {
        localStorage.setItem('auth_result', __WEBPACK_IMPORTED_MODULE_3_auth0_js__["a" /* default */]);
        if (authResult && authResult.accessToken && authResult.idToken) {
          _this.setSession(authResult);
          __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].replace('home');
        } else if (err) {
          __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].replace('home');
          console.log(err);
          alert('Error: ' + err.error + '. Check the console for further details.');
        }
      });
    }
  }, {
    key: 'setSession',
    value: function setSession(authResult) {
      var expiresAt = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(authResult.expiresIn * 1000 + new Date().getTime());
      localStorage.setItem('access_token', authResult.accessToken);
      localStorage.setItem('id_token', authResult.idToken);
      localStorage.setItem('expires_at', expiresAt);
      this.authNotifier.emit('authChange', { authenticated: true });
    }
  }, {
    key: 'logout',
    value: function logout() {
      localStorage.removeItem('access_token');
      localStorage.removeItem('id_token');
      localStorage.removeItem('expires_at');
      this.userProfile = null;
      this.authNotifier.emit('authChange', false);

      __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].replace('home');
    }
  }, {
    key: 'isAuthenticated',
    value: function isAuthenticated() {
      var expiresAt = JSON.parse(localStorage.getItem('expires_at'));
      return new Date().getTime() < expiresAt;
    }
  }]);

  return AuthService;
}();

/* harmony default export */ __webpack_exports__["a"] = (AuthService);

/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTH_CONFIG; });
var AUTH_CONFIG = {
  clientId: 'coQuRq71S7Um7KpM3xZr76XKb8vEjCMH',
  domain: 'acestowncar.auth0.com',
  callbackUrl: 'https://alpha.acestowncarservice.com/callback',
  apiUrl: 'https://twosteau-qa.acestowncarservice.com'
};

/***/ }),
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(40);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e87f57c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(179);
function injectStyle (ssrContext) {
  __webpack_require__(96)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e87f57c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(180)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(97);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("d3275ebc", content, true, {});

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "a{cursor:pointer}body{background-color:#fff}.ui.menu .item img.logo{margin-right:1.5em}.main.container{margin-top:7em}.wireframe{margin-top:2em}.ui.footer.segment{margin:5em 0 0;padding:5em 0}.ui.fluid.positive.button.reqbutton,.ui.fluid.primary.button.reqbutton,.ui.fluid.secondary.button.reqbutton{margin-bottom:.5em;margin-top:.5em}", ""]);

// exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summary_vue__ = __webpack_require__(41);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61ca1854_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summary_vue__ = __webpack_require__(101);
function injectStyle (ssrContext) {
  __webpack_require__(99)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61ca1854_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(100);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1792ad7a", content, true, {});

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui segment"},[_c('div',{staticClass:"ui form"},[_c('h4',[_vm._v("Reservation Info")]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',[_vm._v("Pickup")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.reservation.pickup.formatted))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',[_vm._v("Dropoff")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.reservation.dropoff.formatted))])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',[_vm._v("Requested Vehicle Type")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.getVehicleType()))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Locations_vue__ = __webpack_require__(42);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58bd7f77_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Locations_vue__ = __webpack_require__(113);
function injectStyle (ssrContext) {
  __webpack_require__(103)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Locations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58bd7f77_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Locations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(114)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(104);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("3578162e", content, true, {});

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "a.errorlink{color:#fff;text-decoration:underline}#passenger-menu,#type-menu{max-height:300px}", ""]);

// exports


/***/ }),
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return shakespeare; });
var shakespeare = {
  data: function data() {
    return {
      quote: '',
      inProgress: false
    };
  },
  methods: {
    getQuote: function getQuote(pickup, dropoff) {
      var passengers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      var v = this;

      var origin = encodeURIComponent(pickup);
      var destination = encodeURIComponent(dropoff);
      var host = "https://k8s.hacksy-do.com/shakespeare";
      var path = '/quote?origin=' + origin + '&destination=' + destination;

      $.ajax({
        url: host + path,
        type: 'GET',
        dataType: 'json',
        beforeSend: function beforeSend() {
          v.inProgress = true;
          v.$emit('quoteInProgress', v.inProgress);
        },
        success: function success(data) {
          data.quotes = data.quotes.filter(function (quote) {
            return quote.maxPassengers >= passengers;
          });
          v.quote = data;
          v.$emit('quoteReceived', v.quote);
        },
        complete: function complete() {
          v.inProgress = false;
          v.$emit('quoteInProgress', v.inProgress);
        }
      });
    }
  }
};

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui segment",class:{ loading: _vm.quoteInProgress }},[_c('div',{staticClass:"ui form"},[_c('div',{staticClass:"field"},[_c('label',[_vm._v(_vm._s(_vm.$t('reservation.type.inputLabel')))]),_vm._v(" "),_c('div',{staticClass:"ui selection dropdown",on:{"change":function($event){_vm.reactToType()}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],attrs:{"type":"hidden","id":"reservation-type","name":"reservation-type"},domProps:{"value":(_vm.selected)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selected=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"dropdown icon"}),_vm._v(" "),_c('div',{staticClass:"default text"},[_vm._v(_vm._s(_vm.$t('reservation.type.placeholder')))]),_vm._v(" "),_c('div',{staticClass:"sub menu",staticStyle:{"maxheight":"100%"},attrs:{"id":"type-menu"}},[_c('div',{staticClass:"item",attrs:{"data-value":"1"}},[_vm._v(_vm._s(_vm.$t('reservation.type.toAirport')))]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"2"}},[_vm._v(_vm._s(_vm.$t('reservation.type.fromAirport')))]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"3"}},[_vm._v(_vm._s(_vm.$t('reservation.type.pointToPoint')))]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"4"}},[_vm._v(_vm._s(_vm.$t('reservation.type.multipleStop')))]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"4"}},[_vm._v(_vm._s(_vm.$t('reservation.type.hourly')))]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"4"}},[_vm._v(_vm._s(_vm.$t('reservation.type.weddings')))])])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',[_vm._v("Pickup")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pickupDisplay),expression:"pickupDisplay"}],attrs:{"disabled":_vm.pickupDisplay == 'Sea-Tac Airport',"type":"text","id":"pickup","name":"pickup","placeholder":"Pickup Address"},domProps:{"value":(_vm.pickupDisplay)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pickupDisplay=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',[_vm._v("Dropoff")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dropoffDisplay),expression:"dropoffDisplay"}],attrs:{"disabled":_vm.dropoffDisplay == 'Sea-Tac Airport',"type":"text","id":"dropoff","name":"dropoff","placeholder":"Dropoff Address"},domProps:{"value":(_vm.dropoffDisplay)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dropoffDisplay=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',[_vm._v(_vm._s(_vm.$t('reservation.passengerCount.inputLabel')))]),_vm._v(" "),_c('div',{staticClass:"ui selection dropdown",on:{"change":function($event){_vm.validatePassengers()}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.passengers),expression:"passengers"}],attrs:{"id":"passengers","type":"hidden","name":"passengers"},domProps:{"value":(_vm.passengers)},on:{"input":function($event){if($event.target.composing){ return; }_vm.passengers=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"dropdown icon"}),_vm._v(" "),_c('div',{staticClass:"default text"},[_vm._v(_vm._s(_vm.$t('reservation.passengerCount.placeholder')))]),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_vm._l((_vm.errors),function(error,index){return _c('div',{key:index,staticClass:"ui red inverted segment"},[_c('span',{domProps:{"innerHTML":_vm._s(error)}})])}),_vm._v(" "),_c('div',{staticClass:"ui modal",attrs:{"id":"unsupportedRideTypeModal"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',[_vm._v(_vm._s(_vm.$t('reservation.type.typeError')))])]),_vm._v(" "),_vm._m(2)])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu",attrs:{"id":"passenger-menu"}},[_c('div',{staticClass:"item",attrs:{"data-value":"1"}},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"3"}},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"4"}},[_vm._v("4")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"5"}},[_vm._v("5")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"6"}},[_vm._v("6")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"99"}},[_vm._v("7+")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('p',[_vm._v("Sorry!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui approve button"},[_vm._v("Let's Go!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reservation":{"type":{"inputLabel":"Reservation Type","placeholder":"Select ride type...","toAirport":"To Airport: Sea-Tac (Departing)","fromAirport":"From Airport: Sea-Tac (Arriving)","pointToPoint":"Point-to-Point","multipleStop":"Multiple Stops","hourly":"Hourly","weddings":"Weddings","typeError":"Online booking is not available for hourly, event, or multiple stop reservations. Please use our reservation request form."},"passengerCount":{"inputLabel":"Passengers","placeholder":"Number of passengers...","maxPassengerError":"Online booking is currently only available for vehicles up to 6 passengers. For larger groups, please make a request using our form for larger vehicles at <a class=\u0027errorlink\u0027 href=\u0027https://acestowncarservice.com/aces-vehicle-quote/\u0027>https://acestowncarservice.com/aces-vehicle-quote/</a>"}}}}')
  delete Component.options._Ctor
}


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateTime_vue__ = __webpack_require__(47);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17466226_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateTime_vue__ = __webpack_require__(118);
function injectStyle (ssrContext) {
  __webpack_require__(116)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DateTime_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17466226_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DateTime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(117);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("de951350", content, true, {});

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui segment"},[_c('h4',{staticClass:"ui header"},[_vm._v("Scheduling Information")]),_vm._v(" "),_c('div',{staticClass:"ui form"},[_c('div',{staticClass:"fields"},[_c('div',{staticClass:"eight wide field"},[_c('label',[_vm._v("Pickup Date")]),_vm._v(" "),_c('div',{staticClass:"ui left icon input"},[_c('input',{attrs:{"type":"text","id":"date","name":"date","v-model":_vm.date,"placeholder":"Pickup Date/Time"}}),_vm._v(" "),_c('i',{staticClass:"calendar alternate outline icon"})])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),(_vm.showError())?_c('div',{staticClass:"ui red message"},[_vm._m(1)]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"eight wide field"},[_c('label',[_vm._v("Pickup Time")]),_vm._v(" "),_c('div',{staticClass:"ui left icon input"},[_c('input',{attrs:{"type":"text","id":"time","name":"time","placeholder":"Pickup Date/Time"}}),_vm._v(" "),_c('i',{staticClass:"clock outline icon"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Pickup time must be at least 4 hours from now to use our online booking. Please email "),_c('a',{attrs:{"href":"mailto:reservations@acestowncarservice.com"}},[_vm._v("reservations@acestowncarservice.com")]),_vm._v(" and we will work to get you scheduled for service.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(120);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("e7062cea", content, true, {});

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 121 */,
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui segment"},[_c('h4',{staticClass:"ui header"},[_vm._v(_vm._s(_vm.getHeader()))]),_vm._v(" "),_c('div',{staticClass:"ui form"},[(_vm.authenticated)?_c('div',{staticClass:"field"},[_c('div',{staticClass:"ui selection dropdown contact-type"},[_c('input',{attrs:{"type":"hidden","name":"saved-contact","value":"new"},on:{"change":_vm.selectSaved}}),_vm._v(" "),_c('i',{staticClass:"dropdown icon"}),_vm._v(" "),_c('div',{staticClass:"default text"}),_vm._v(" "),_c('div',{staticClass:"menu"},[_c('div',{staticClass:"item",attrs:{"data-value":"new"}},[_vm._v("Create new contact...")]),_vm._v(" "),_vm._l((_vm.savedContacts),function(contact,index){return _c('div',{key:index,staticClass:"item",attrs:{"data-value":index}},[_vm._v(_vm._s(contact.firstName)+" "+_vm._s(contact.lastName))])})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"eight wide field",class:{ disabled: _vm.selectedContact !== 'new' }},[_c('label',[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.firstName),expression:"firstName"}],attrs:{"type":"text","name":"first-name"},domProps:{"value":(_vm.firstName)},on:{"change":function($event){_vm.checkForComplete()},"input":function($event){if($event.target.composing){ return; }_vm.firstName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"eight wide field",class:{ disabled: _vm.selectedContact !== 'new' }},[_c('label',[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lastName),expression:"lastName"}],attrs:{"type":"text","name":"last-name"},domProps:{"value":(_vm.lastName)},on:{"change":function($event){_vm.checkForComplete()},"input":function($event){if($event.target.composing){ return; }_vm.lastName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"field",class:{ disabled: _vm.selectedContact !== 'new' }},[_c('label',[_vm._v("Email Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"type":"text","name":"email"},domProps:{"value":(_vm.email)},on:{"change":function($event){_vm.checkForComplete()},"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"field",class:{ disabled: _vm.selectedContact !== 'new' }},[_c('label',[_vm._v("Phone Number")]),_vm._v(" "),_c('imask-input',{attrs:{"mask":'(000) 000-0000',"lazy":true,"radix":"."},on:{"change":function($event){_vm.checkForComplete()}},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})],1),_vm._v(" "),_c('div',{staticClass:"two fields"},[_c('div',{staticClass:"inline field",class:{ disabled: _vm.selectedContact !== 'new' }},[_c('div',{staticClass:"ui checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.smsEnabled),expression:"smsEnabled"}],staticClass:"hidden",attrs:{"type":"checkbox","checked":"","tabindex":"0"},domProps:{"checked":Array.isArray(_vm.smsEnabled)?_vm._i(_vm.smsEnabled,null)>-1:(_vm.smsEnabled)},on:{"change":[function($event){var $$a=_vm.smsEnabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.smsEnabled=$$a.concat([$$v]))}else{$$i>-1&&(_vm.smsEnabled=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.smsEnabled=$$c}},function($event){_vm.checkForComplete()}]}}),_vm._v(" "),_c('label',[_vm._v("Allow text messages for this number")])])]),_vm._v(" "),(_vm.authenticated && _vm.selectedContact === 'new')?_c('div',{staticClass:"inline field"},[_c('div',{staticClass:"ui checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.saveAddress),expression:"saveAddress"}],staticClass:"hidden",attrs:{"type":"checkbox","checked":"","tabindex":"0"},domProps:{"checked":Array.isArray(_vm.saveAddress)?_vm._i(_vm.saveAddress,null)>-1:(_vm.saveAddress)},on:{"change":[function($event){var $$a=_vm.saveAddress,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.saveAddress=$$a.concat([$$v]))}else{$$i>-1&&(_vm.saveAddress=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.saveAddress=$$c}},function($event){_vm.checkForComplete()}]}}),_vm._v(" "),_c('label',[_vm._v("Save this address")])])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quote_vue__ = __webpack_require__(52);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f8701a9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quote_vue__ = __webpack_require__(129);
function injectStyle (ssrContext) {
  __webpack_require__(124)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quote_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f8701a9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quote_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(125);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("7a077d52", content, true, {});

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".card.dimmed{opacity:.5}", ""]);

// exports


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(127);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("5cb5323e", content, true, {});

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"ui two column table"},[_c('tbody',_vm._l((_vm.lineItems()),function(lineItem,index){return (lineItem.lineItemType !== 'total')?_c('tr',{key:index},[(lineItem.lineItemType === 'serviceCharge' && !_vm.showFeeInfo)?_c('td',{staticClass:"line item description"},[_c('a',{on:{"click":function($event){_vm.showServiceFeeModal()}}},[_vm._v(_vm._s(lineItem.lineItemDescription))])]):_c('td',[_vm._v(_vm._s(lineItem.lineItemDescription))]),_vm._v(" "),_c('td',{staticClass:"right aligned"},[_vm._v(_vm._s(_vm.formatDollars(lineItem.lineItemCost)))])]):_vm._e()})),_vm._v(" "),_c('tfoot',[_c('tr',[_c('th',[_vm._v("Total")]),_vm._v(" "),_c('th',{staticClass:"right aligned"},[_vm._v(_vm._s(_vm.formatDollars(_vm.total())))])])])]),_vm._v(" "),(_vm.showFeeInfo)?_c('div',{staticClass:"ui blue segment inverted"},[_c('p',[_vm._v(_vm._s(_vm.serviceFeeInfo()))])]):_c('div',{staticClass:"ui modal",attrs:{"id":"serviceFeeInfoModal"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',[_vm._v(_vm._s(_vm.serviceFeeInfo()))])]),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('p',[_vm._v("Service Fee Information")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui approve button"},[_vm._v("Thanks")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui segment"},[_c('h4',{staticClass:"ui header"},[_vm._v("Quote")]),_vm._v(" "),_c('div',{staticClass:"ui two cards"},_vm._l((_vm.reservation.quote.quotes),function(quote,index){return _c('div',{key:index,staticClass:"ui card",class:{ dimmed: _vm.selected != null && index != _vm.selected }},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.getImageUrl(quote.vehicleName)},on:{"click":function($event){_vm.selectReservation(quote, index)}}})]),_vm._v(" "),_c('div',{staticClass:"content center aligned"},[_c('p',{staticClass:"header"},[_vm._v(_vm._s(quote.vehicleName))]),_vm._v(" "),_c('i',{staticClass:"user icon"}),_vm._v(" "+_vm._s(quote.maxPassengers)+"    |    "),_c('i',{staticClass:"suitcase icon"}),_vm._v(" "+_vm._s(quote.maxPassengers)+"\n          "),_c('div',{staticClass:"meta"},[_vm._v("\n            "+_vm._s(quote.vehicleDescription)+"\n          ")]),_vm._v(" "),_c('h2',{staticClass:"ui center aligned"},[_vm._v("\n            "+_vm._s(_vm.formatDollars(_vm.getBaseFareFromFare(_vm.getAirportFareFromQuote(quote)).lineItemCost))+"\n          ")]),_vm._v(" "),_c('p',{staticClass:"ui center aligned"},[_c('a',{on:{"click":function($event){_vm.showModal('quote-' + index)}}},[_vm._v("+ Fees "),_c('i',{staticClass:"info circle icon"})])])]),_vm._v(" "),_c('div',{staticClass:"extra content"},[(_vm.selected != null)?_c('div',[(_vm.selected == index)?_c('div',[_c('button',{staticClass:"fluid ui green button",on:{"click":function($event){_vm.selectReservation(quote, index)}}},[_vm._v("Selected")])]):_c('div',[_c('button',{staticClass:"fluid ui button",on:{"click":function($event){_vm.selectReservation(quote, index)}}},[_vm._v("Select Vehicle")])])]):_c('div',[_c('button',{staticClass:"fluid ui blue button",on:{"click":function($event){_vm.selectReservation(quote, index)}}},[_vm._v("Select Vehicle")])])]),_vm._v(" "),_c('div',{staticClass:"ui modal",attrs:{"id":'quote-' + index}},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(quote.vehicleName))]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('CostTable',{attrs:{"showFeeInfo":true,"fareLineItems":quote.fares[0].fareLineItems}})],1),_vm._v(" "),_vm._m(0,true)])])}))])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui approve button"},[_vm._v("OK")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Request_vue__ = __webpack_require__(56);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e13f63a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Request_vue__ = __webpack_require__(170);
function injectStyle (ssrContext) {
  __webpack_require__(131)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Request_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e13f63a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Request_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(171)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(132);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("56914012", content, true, {});

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TermsOfService; });
var TermsOfService = {
  verbose: "<p>Submitting any request though the Aces Town Car Service reservation system signifies that the client has read the terms and conditions stated below and agrees to all stated terms and conditions.</p>\n  \n  <h3>Maintenance and Mechanics</h3>\n  \n  <p>Aces\u2019 is not liable in the event of mechanical breakdown while on charter and will only be responsible for making up lost time at a mutually agreed date. Client assumes full financial liability for any damage to the vehicle caused during the duration of the rental by the client or any members of their party. Total sanitation cost will be assessed by a certified technician and billed to client for spillage of drinks, food, vomiting, etc. Client agrees that smoking and/or alcohol consumption is not permitted in our vehicles. The driver has the right to terminate transportation without refund if there is a blatant indiscretion on the part of a client.</p>\n  \n  <h3>Charges</h3>\n  \n  <p>The rate charged for transportation services before wait times and/or tolls.</p>\n  \n  <h3>Fuel Surcharge</h3>\n  \n  <p>Fuel surcharge is updated every Monday and based upon the weekly Seattle average price for regular unleaded grade fuel as published by the DOE at <a target=\"_blank\" href=\"http://tonto.eia.doe.gov/dnav/pet/pet_pri_gnd_dcus_nus_w.htm\">http://tonto.eia.doe.gov/dnav/pet/pet_pri_gnd_dcus_nus_w.htm</a></p>\n  \n  <p>Below $3.00 per gallon 1% Fuel Surcharge<br/>\n  $3.01 - $3.25 per gallon 2% Fuel Surcharge<br/>\n  $3.26 - $3.50 per gallon 3% Fuel Surcharge<br/>\n  $3.51 - $3.75 per gallon 4% Fuel Surcharge<br/>\n  $3.76 - $4.00 per gallon 5% Fuel Surcharge<br/>\n  $4.01 - $4.25 per gallon 6% Fuel Surcharge<br/>\n  $4.26 - $4.50 per gallon 7% Fuel Surcharge<br/>\n  $4.51 - $4.75 per gallon 8% Fuel Surcharge</p>\n  \n  <h3>Wait Time</h3>\n  \n  <p>All clients receive a 10-minute grace period after time of scheduled service from originating pick-up location, after which, a $1.00 per minute wait charge will be added to base charge for sedan reservations and $1.50 per minute for SUV reservations.</p>\n  \n  <h3>Estimated Quote</h3>\n  \n  <p>Rates quoted prior to service are only an initial estimate of cost of services reserved. Change of pickup or dropoff address, wait time, tolls, additional stops and/or additional services may change the final price.</p>\n  \n  <h3>Weather</h3>\n  \n  <p>Aces Town Car Service is not responsible for delays or the termination of service in Winter weather which causes unsafe road conditions that could potentially put clients and chauffeurs in danger. Aces' will give proper notification of this weather cancellation to all clients.</p>\n  \n  <h3>Lost and Found</h3>\n  \n  <p>Aces will not be held responsible for articles left in vehicles. Personal items that have been left in a vehicle are sometimes returned to the Aces office. Emailing a description of such items to lostandfound@acestowncarservice.com could result in the recovery of such items if they have been found. Recovery of items is not guaranteed.</p>\n  \n  <h3>Seating Capacity</h3>\n  \n  <p>Vehicles cannot be loaded beyond seating or luggage capacity. Requesting a vehicle that does not accommodate the number of passengers and/or luggage at pickup location will result in cancellation of service and charged the full base rate.</p>\n  \n  <h3>Child Safety Seats</h3>\n  \n  <p>For safety reasons of providing age and weight appropriate equipment, Aces does not provide child safety or booster seats. However, clients may provide and install their own child safety or booster seats. For an explanation of Washington State Child Car Seat Laws, please visit <a target=\"_blank\" href=\"http://www.dmv.org/wa-washington/safety-laws.php#Child-Car-Seat\">http://www.dmv.org/wa-washington/safety-laws.php#Child-Car-Seat</a></p>\n  \n  <h3>Cancellation and No-Show Policy</h3>\n  \n  <p>Cancellations must be made no less than four (4) hours in advance to avoid a cancellation charge of the full rate for Point to Points and Airport Transportation reservations. Hourly Bookouts must be cancelled with no less than a twenty-four (24) hour advance notice to avoid a cancellation charge of the full rate. Cancellations due to a cancelled airline flight cannot be made unless given three (3) hours advance notice and verification by Aces of cancellation by airline to avoid a cancellation charge of the full rate. All clients who do not show up for their reserved transportation will be considered a no-show and will be charged the full rate of their reservation.</p>\n  \n  <h3>Privacy Policy</h3>\n  \n  <p>Your name and personal information will only be used by Aces' or its contractors for the purpose of rendering service or to collect payments for services rendered. Your email address is used for sending confirmations, information and service enhancements. Our full privacy policy can be found at <a href=\"http://acestowncarservice.com/privacypolicy\" target=\"_blank\">http://acestowncarservice.com/privacypolicy</a></p>\n  \n  <h3>Terms of Use</h3>\n  \n  <p>Aces' full Terms of Use can be found at <a href=\"http://acestowncarservice.com/termsofuse\" target=\"_blank\">http://acestowncarservice.com/termsofuse</a></p>"
};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(135);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("3d33efce", content, true, {});

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return anet; });
var anet = {
  data: function data() {
    return {
      inProgress: false
    };
  },
  methods: {
    getNonce: function getNonce(cardNumber, expMonth, expYear, cardCode, responseHandler) {
      var authData = {};
      authData.clientKey = '5VLXFaBRqsqM4w4QybN9M7KW3zsug466vhxhM84YRQm26bZheJdEQ3gdHp3bZuFZ';
      authData.apiLoginID = '65jUFHbj4b38';

      var cardData = {};
      cardData.cardNumber = cardNumber;
      cardData.month = expMonth;
      cardData.year = expYear;
      cardData.cardCode = cardCode;

      var secureData = {};
      secureData.authData = authData;
      secureData.cardData = cardData;

      Accept.dispatchData(secureData, responseHandler);
    }
  }
};

/***/ }),
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{staticClass:"ui form",attrs:{"id":"paymentForm"}},[_c('input',{attrs:{"type":"hidden","name":"dataValue","id":"dataValue"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"dataDescriptor","id":"dataDescriptor"}}),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',[_vm._v(_vm._s(_vm.$t('paymentType.label')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.paymentType),expression:"paymentType"}],staticClass:"ui fluid search dropdown",attrs:{"name":"expMonth"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.paymentType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.checkOnChange()}]}},[_c('option',{attrs:{"value":"cc"}},[_vm._v(_vm._s(_vm.$t('paymentType.creditCard')))]),_vm._v(" "),_c('option',{attrs:{"value":"acct"}},[_vm._v(_vm._s(_vm.$t('paymentType.account')))])])]),_vm._v(" "),(_vm.paymentType === 'acct')?_c('div',[_c('div',{staticClass:"fields"},[_c('div',{staticClass:"sixteen wide field"},[_c('label',[_vm._v(_vm._s(_vm.$t('accountCode.label')))]),_vm._v(" "),_c('imask-input',{attrs:{"mask":'aa-00000-a',"lazy":true,"radix":".","type":"text","name":"accountCode","id":"accountCode","maxlength":"16","placeholder":_vm.$t('accountCode.placeholder')},on:{"change":function($event){_vm.checkOnChange()}},model:{value:(_vm.accountCode),callback:function ($$v) {_vm.accountCode=$$v},expression:"accountCode"}})],1)])]):_vm._e(),_vm._v(" "),(_vm.paymentType === 'cc')?_c('div',[_c('div',{staticClass:"fields"},[_c('div',{staticClass:"seven wide field"},[_c('label',[_vm._v(_vm._s(_vm.$t('creditCard.number.label')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardInfo.cardNumber),expression:"cardInfo.cardNumber"}],attrs:{"type":"text","name":"cardNumber","id":"cardNumber","maxlength":"16","placeholder":_vm.$t('creditCard.number.placeholder')},domProps:{"value":(_vm.cardInfo.cardNumber)},on:{"change":function($event){_vm.checkOnChange()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cardInfo, "cardNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"three wide field"},[_c('label',[_vm._v(_vm._s(_vm.$t('creditCard.code.label')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardInfo.cardCode),expression:"cardInfo.cardCode"}],attrs:{"type":"text","name":"cardCode","id":"cardCode","maxlength":"4","placeholder":_vm.$t('creditCard.code.placeholder')},domProps:{"value":(_vm.cardInfo.cardCode)},on:{"change":function($event){_vm.checkOnChange()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cardInfo, "cardCode", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"six wide field"},[_c('label',[_vm._v(_vm._s(_vm.$t('creditCard.expiration.label')))]),_vm._v(" "),_c('div',{staticClass:"two fields"},[_c('div',{staticClass:"field"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardInfo.cardExpMonth),expression:"cardInfo.cardExpMonth"}],staticClass:"ui fluid search dropdown",attrs:{"name":"expMonth"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.cardInfo, "cardExpMonth", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.checkOnChange()}]}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('creditCard.expiration.month.placeholder')))]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v(_vm._s(_vm.$t('creditCard.expiration.month.jan')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v(_vm._s(_vm.$t('creditCard.expiration.month.feb')))]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v(_vm._s(_vm.$t('creditCard.expiration.month.mar')))]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v(_vm._s(_vm.$t('creditCard.expiration.month.apr')))]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v(_vm._s(_vm.$t('creditCard.expiration.month.may')))]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v(_vm._s(_vm.$t('creditCard.expiration.month.jun')))]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v(_vm._s(_vm.$t('creditCard.expiration.month.jul')))]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v(_vm._s(_vm.$t('creditCard.expiration.month.aug')))]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v(_vm._s(_vm.$t('creditCard.expiration.month.sep')))]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v(_vm._s(_vm.$t('creditCard.expiration.month.oct')))]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v(_vm._s(_vm.$t('creditCard.expiration.month.nov')))]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v(_vm._s(_vm.$t('creditCard.expiration.month.dec')))])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardInfo.cardExpYear),expression:"cardInfo.cardExpYear"}],staticClass:"ui fluid search dropdown",attrs:{"name":"expYear"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.cardInfo, "cardExpYear", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.checkOnChange()}]}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('creditCard.expiration.year.placeholder')))]),_vm._v(" "),_vm._l((50),function(index){return _c('option',{key:index,domProps:{"value":index + 2018}},[_vm._v("\n                    "+_vm._s(index + 2018)+"\n                  ")])})],2)])])])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"paymentType":{"label":"Payment Type","creditCard":"Credit Card","account":"Account Code"},"accountCode":{"label":"Account Code","placeholder":"Existing Account Code"},"creditCard":{"number":{"label":"Credit Card","placeholder":"Card #"},"expiration":{"label":"Expiration","month":{"placeholder":"Month","jan":"January","feb":"February","mar":"March","apr":"April","may":"May","jun":"June","jul":"July","aug":"August","sep":"September","oct":"October","nov":"November","dec":"December"},"year":{"placeholder":"Year"}},"code":{"label":"CVC","placeholder":"CVC"}}}}')
  delete Component.options._Ctor
}


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui segment"},[_c('h4',{staticClass:"ui header"},[_vm._v("Quote")]),_vm._v(" "),_c('CostTable',{attrs:{"fareLineItems":_vm.lineItems(),"showFeeInfo":false}}),_vm._v(" "),_c('Payment',{on:{"paymentFunctionUpdated":_vm.onPaymentFunctionUpdated}}),_vm._v(" "),_c('div',{staticClass:"ui form"},[(_vm.reservation.selectedQuote.vehCode === 'sedan')?_c('div',{staticClass:"inline field"},[_c('div',{staticClass:"ui checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.upgrades),expression:"upgrades"}],staticClass:"hidden",attrs:{"type":"checkbox","checked":"","tabindex":"0"},domProps:{"checked":Array.isArray(_vm.upgrades)?_vm._i(_vm.upgrades,null)>-1:(_vm.upgrades)},on:{"change":[function($event){var $$a=_vm.upgrades,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.upgrades=$$a.concat([$$v]))}else{$$i>-1&&(_vm.upgrades=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.upgrades=$$c}},function($event){_vm.onUpdate()}]}}),_vm._v(" "),_c('label',[_vm._v("Allow SUV upgrade at no additional charge if a sedan is unavailable")])])]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("Please note that this is a reservation request and does not guarantee service until it has been reviewed and accepted by Aces Town Car Service. You will receive an email when your reservation has been accepted. Reservations must be canceled at least 4 hours in advance to avoid being held responsible for payment. By making this reservation, you acknowledge you have read and agree to our "),_c('a',{on:{"click":function($event){_vm.showTermsOfService()}}},[_vm._v(" complete terms and conditions")]),_vm._v(".")]),_vm._v(" "),_c('div',{staticClass:"inline field"},[_c('div',{staticClass:"ui checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tosAgreed),expression:"tosAgreed"}],staticClass:"hidden",attrs:{"type":"checkbox","tabindex":"0"},domProps:{"checked":Array.isArray(_vm.tosAgreed)?_vm._i(_vm.tosAgreed,null)>-1:(_vm.tosAgreed)},on:{"change":[function($event){var $$a=_vm.tosAgreed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.tosAgreed=$$a.concat([$$v]))}else{$$i>-1&&(_vm.tosAgreed=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.tosAgreed=$$c}},function($event){_vm.onUpdate()}]}}),_vm._v(" "),_c('label',[_vm._v("I have read and agree to the above terms and conditions")])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',[_vm._v("Additional Notes")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clientNotes),expression:"clientNotes"}],attrs:{"type":"text","name":"email","placeholder":"Driver instructions, Apt/Ste#, etc."},domProps:{"value":(_vm.clientNotes)},on:{"change":function($event){_vm.onUpdate()},"input":function($event){if($event.target.composing){ return; }_vm.clientNotes=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"ui longer modal"},[_c('div',{staticClass:"header"},[_vm._v("Service Terms and Conditions")]),_vm._v(" "),_c('div',{staticClass:"scrolling content",domProps:{"innerHTML":_vm._s(_vm.termsOfService())}}),_vm._v(" "),_vm._m(0)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui approve button"},[_vm._v("Agree")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"header":"Payment and Confirmation","suvUpgrade":{"checkbox":{"label":"Allow SUV upgrade at no additional charge if a sedan is unavailable"}},"tos":{"checkbox":{"label":"I have read and agree to the above terms and conditions"}}}}')
  delete Component.options._Ctor
}


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(173);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("de1755d0", content, true, {});

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ui segment"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"ui form"},[_c('div',{staticClass:"fields"},[_c('div',{staticClass:"field"},[_c('label',[_vm._v("Reference Code")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.confirmedReservation.refCode))])])]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"field"},[_c('label',[_vm._v("Pickup Time")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.formatFriendlyDate(_vm.confirmedReservation.pickupDateTime)))])])]),_vm._v(" "),_vm._l((_vm.confirmedReservation.addresses),function(address,index){return _c('div',{key:index,staticClass:"fields"},[_c('div',{staticClass:"field"},[_c('label',[_vm._v(_vm._s(_vm.initialCaps(address.type))+" Address")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(address.streetAddress)+", "+_vm._s(address.city)+", "+_vm._s(address.state)+" "+_vm._s(address.zip))])])])}),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"field"},[_c('label',[_vm._v("Vehicle Type")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.initialCaps(_vm.confirmedReservation.vehicleRequest.vehicleType)))])])]),_vm._v(" "),(_vm.confirmedReservation.clientNotes !== '')?_c('div',{staticClass:"fields"},[_c('div',{staticClass:"field"},[_c('label',[_vm._v("Additional Notes")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.confirmedReservation.clientNotes))])])]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"ui segment"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"ui form"},_vm._l((_vm.confirmedReservation.contacts),function(contact,index){return _c('div',{key:index,staticClass:"fields"},[_c('div',{staticClass:"field"},[_c('label',[_vm._v(_vm._s(_vm.initialCaps(contact.type)))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(contact.firstName)+" "+_vm._s(contact.lastName)),_c('br'),_vm._v("\n        "+_vm._s(contact.email)),_c('br'),_vm._v("\n        "+_vm._s(_vm.formatUSPhone(contact.phone)))])])])}))]),_vm._v(" "),_c('div',{staticClass:"ui segment"},[_vm._m(2),_vm._v(" "),_c('table',{staticClass:"ui two column table"},[_c('tbody',_vm._l((_vm.confirmedReservation.quoteInfo.lineItems),function(lineItem,index){return (lineItem.type !== 'total')?_c('tr',{key:index},[_c('td',[_vm._v(_vm._s(lineItem.description))]),_vm._v(" "),_c('td',{staticClass:"right aligned"},[_vm._v(_vm._s(_vm.formatDollars(lineItem.cost)))])]):_vm._e()})),_vm._v(" "),_c('tfoot',_vm._l((_vm.confirmedReservation.quoteInfo.lineItems),function(lineItem,index){return (lineItem.type === 'total')?_c('tr',{key:index},[_c('th',[_vm._v(_vm._s(lineItem.description))]),_vm._v(" "),_c('th',{staticClass:"right aligned"},[_vm._v(_vm._s(_vm.formatDollars(lineItem.cost)))])]):_vm._e()}))]),_vm._v(" "),_c('table',{staticClass:"ui two column table"},[_c('tbody',[_c('tr',[_c('td',[_vm._v("Payment Type")]),_vm._v(" "),_c('td',{staticClass:"right aligned"},[_vm._v(_vm._s(_vm.getPaymentType()))])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"ui horizontal divider header"},[_c('i',{staticClass:"map marker alternate icon"}),_vm._v("\n    Reservation Info\n  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"ui horizontal divider header"},[_c('i',{staticClass:"user icon"}),_vm._v("\n    Contacts\n  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"ui horizontal divider header"},[_c('i',{staticClass:"file alternate outline icon"}),_vm._v("\n    Receipt\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(176);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("4e22130e", content, true, {});

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui segment",class:{ loading: _vm.flightInfoInProgress }},[_c('h4',{staticClass:"ui header"},[_vm._v(_vm._s(_vm.$t('flight.header')))]),_vm._v(" "),_c('div',{staticClass:"ui form"},[(!_vm.flightInfoCompleteValue)?_c('div',[_c('div',{staticClass:"field"},[_c('label',[_vm._v(_vm._s(_vm.$t('flight.arrivalDateTime.inputLabel')))]),_vm._v(" "),_c('div',{staticClass:"ui left icon input"},[_c('input',{attrs:{"type":"text","id":"date","name":"date","placeholder":"Pickup Date/Time"},on:{"change":function($event){_vm.reset()}}}),_vm._v(" "),_c('i',{staticClass:"calendar alternate outline icon"})])]),_vm._v(" "),_c('div',{staticClass:"fields"},[_c('div',{staticClass:"twelve wide field"},[_c('label',[_vm._v(_vm._s(_vm.$t('flight.airline.inputLabel')))]),_vm._v(" "),_c('div',{staticClass:"ui search selection dropdown"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.airline),expression:"airline"}],attrs:{"type":"hidden","name":"passengers"},domProps:{"value":(_vm.airline)},on:{"change":_vm.selectAirline,"input":function($event){if($event.target.composing){ return; }_vm.airline=$event.target.value}}}),_vm._v(" "),_c('i',{staticClass:"dropdown icon"}),_vm._v(" "),_c('div',{staticClass:"default text"},[_vm._v(_vm._s(_vm.$t('flight.airline.placeholder')))]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"four wide field"},[_c('label',[_vm._v(_vm._s(_vm.$t('flight.flightNo.inputLabel')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.flightNo),expression:"flightNo"}],attrs:{"type":"text","name":"first-name","placeholder":_vm.$t('flight.flightNo.placeholder')},domProps:{"value":(_vm.flightNo)},on:{"change":function($event){_vm.reset()},"input":function($event){if($event.target.composing){ return; }_vm.flightNo=$event.target.value}}})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"ui field"},[_c('div',{staticClass:"ui fluid blue submit button",class:{ disabled: !_vm.readyToVerify() },on:{"click":function($event){_vm.verify()}}},[_vm._v(_vm._s(_vm.$t('flight.verify.buttonLabel')))])])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.flightInfoCompleteValue),expression:"flightInfoCompleteValue"}]},[_c('div',{staticClass:"field"},[_c('label',[_vm._v("Scheduled Arrival")]),_vm._v(" "),_c('p',[_vm._v("Flight "+_vm._s(_vm.airline)+" "+_vm._s(_vm.flightNo)),_c('br'),_vm._v("\n        "+_vm._s(_vm._f("moment")(_vm.flightInfo.scheduledArrival,"dddd, MMMM Do [at] h:mm a"))+" from "+_vm._s(_vm.flightInfo.origin))])]),_vm._v(" "),_c('div',{staticClass:"ui checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.meetAndGreet),expression:"meetAndGreet"}],staticClass:"hidden",attrs:{"type":"checkbox","tabindex":"0"},domProps:{"checked":Array.isArray(_vm.meetAndGreet)?_vm._i(_vm.meetAndGreet,null)>-1:(_vm.meetAndGreet)},on:{"change":[function($event){var $$a=_vm.meetAndGreet,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.meetAndGreet=$$a.concat([$$v]))}else{$$i>-1&&(_vm.meetAndGreet=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.meetAndGreet=$$c}},function($event){_vm.reactToMeetAndGreet()}]}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('flight.meetAndGreet.checkboxLabel')))])]),_vm._v(" "),_c('div',{staticClass:"ui checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedBaggage),expression:"checkedBaggage"}],staticClass:"hidden",attrs:{"type":"checkbox","tabindex":"0"},domProps:{"checked":Array.isArray(_vm.checkedBaggage)?_vm._i(_vm.checkedBaggage,null)>-1:(_vm.checkedBaggage)},on:{"change":function($event){var $$a=_vm.checkedBaggage,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedBaggage=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedBaggage=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedBaggage=$$c}}}}),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$t('flight.checkedBags.checkboxLabel')))])]),_vm._v(" "),(_vm.meetAndGreet)?_c('div',{staticClass:"field"},[_c('label',[_vm._v(_vm._s(_vm.$t('flight.meetAndGreet.signInputLabel')))]),_vm._v(" "),_c('div',{staticClass:"ui input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.meetAndGreetSign),expression:"meetAndGreetSign"}],attrs:{"type":"text","id":"meetAndGreetSign","name":"meetAndGreetSign"},domProps:{"value":(_vm.meetAndGreetSign)},on:{"input":function($event){if($event.target.composing){ return; }_vm.meetAndGreetSign=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ui message"},[_c('p',[_vm._v(_vm._s(_vm.serviceInfoMessage()))])])]),_vm._v(" "),(_vm.flightInfoError())?_c('div',{staticClass:"ui red message"},[_vm._v(_vm._s(_vm.$t('flight.verify.error')))]):_vm._e(),_vm._v(" "),(!_vm.valid)?_c('div',{staticClass:"ui red message"},[_vm._m(1)]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('div',{staticClass:"item",attrs:{"data-value":"EI"}},[_vm._v("Aer Lingus")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"AR"}},[_vm._v("Aerolineas")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"AM"}},[_vm._v("Aeromexico")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"AC"}},[_vm._v("Air Canada")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"CA"}},[_vm._v("Air China")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"UX"}},[_vm._v("Air Europa")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"AF"}},[_vm._v("Air France")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"MC"}},[_vm._v("Air Mobility Command")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"TN"}},[_vm._v("Air Tahiti")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"AS"}},[_vm._v("Alaska")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"AZ"}},[_vm._v("Alitalia")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"NH"}},[_vm._v("All Nippon Airways")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"AA"}},[_vm._v("American")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"OZ"}},[_vm._v("Asiana")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"OS"}},[_vm._v("Austrian")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"AV"}},[_vm._v("Avianca")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"BA"}},[_vm._v("British Airways")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"SN"}},[_vm._v("Brussels Airlines")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"CX"}},[_vm._v("Cathay Pacific")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"CI"}},[_vm._v("China Air")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"MU"}},[_vm._v("China Eastern")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"CZ"}},[_vm._v("China Southern")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"DE"}},[_vm._v("Condor")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"CM"}},[_vm._v("COPA")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"DL"}},[_vm._v("Delta")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"LY"}},[_vm._v("El Al")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"EK"}},[_vm._v("Emirates")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"ET"}},[_vm._v("Ethiopian")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"EY"}},[_vm._v("Etihad Airways")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"BR"}},[_vm._v("EVA Air")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"FJ"}},[_vm._v("Fiji Airways")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"AY"}},[_vm._v("Finnair")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"F9"}},[_vm._v("Frontier")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"G3"}},[_vm._v("GOL")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"GF"}},[_vm._v("Gulf Air")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"HU"}},[_vm._v("Hainan Airlines")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"HA"}},[_vm._v("Hawaiian")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"IB"}},[_vm._v("Iberia")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"FI"}},[_vm._v("Icelandair")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"JL"}},[_vm._v("Japan Airlines")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"9W"}},[_vm._v("Jet Airways")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"B6"}},[_vm._v("JetBlue")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"KL"}},[_vm._v("KLM")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"KE"}},[_vm._v("Korean Air")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"LA"}},[_vm._v("Latam")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"LO"}},[_vm._v("LOT - Polish Airlines")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"LH"}},[_vm._v("Lufthansa")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"MH"}},[_vm._v("Malaysia ")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"NZ"}},[_vm._v("New Zealand")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"DI"}},[_vm._v("Norwegian Air")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"QF"}},[_vm._v("Qantas")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"QR"}},[_vm._v("Qatar")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"RJ"}},[_vm._v("Royal Jordanian")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"SK"}},[_vm._v("SAS")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"SQ"}},[_vm._v("Singapore Airlines Cargo")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"SA"}},[_vm._v("So African Airways")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"WN"}},[_vm._v("Southwest")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"NK"}},[_vm._v("Spirit")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"SY"}},[_vm._v("Sun Country")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"LX"}},[_vm._v("Swiss")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"JJ"}},[_vm._v("TAM Linhas Aereas")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"TP"}},[_vm._v("TAP Portugal")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"TG"}},[_vm._v("Thai Airways")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"TK"}},[_vm._v("Turkish Airlines")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"UA"}},[_vm._v("United")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"VN"}},[_vm._v("Vietnam Airlines")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"VS"}},[_vm._v("Virgin Atlantic Airways")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"VA"}},[_vm._v("Virgin Australia")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"Y4"}},[_vm._v("Volaris")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"WS"}},[_vm._v("WestJet")]),_vm._v(" "),_c('div',{staticClass:"item",attrs:{"data-value":"MF"}},[_vm._v("Xiamen")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Pickup time must be at least 4 hours from now to use our online booking. Please email "),_c('a',{attrs:{"href":"mailto:reservations@acestowncarservice.com"}},[_vm._v("reservations@acestowncarservice.com")]),_vm._v(" and we will work to get you scheduled for service.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"flight":{"header":"Flight Information","arrivalDateTime":{"inputLabel":"Arrival Date and Time"},"airline":{"inputLabel":"Airline","placeholder":"Choose an Airline..."},"flightNo":{"inputLabel":"Flight No","placeholder":"Flight No"},"verify":{"buttonLabel":"Verify Flight","error":"Flight not found. Please double-check your information, and contact Aces if you have further trouble."},"checkedBags":{"checkboxLabel":"Checked baggage"},"meetAndGreet":{"checkboxLabel":"Add Meet and Greet ($15)?","signInputLabel":"Meet and Greet Sign Name"},"serviceInfo":{"standard":"Your driver will track your flight and contact you after you have landed.","meetAndGreet":"Your driver will track your flight and meet you at baggage claim afted you have landed."}}}}')
  delete Component.options._Ctor
}


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ui grid"},[_c('div',{staticClass:"sixteen column row"},[_c('div',{staticClass:"sixteen wide column"},[(_vm.showSummary())?_c('Summary',{attrs:{"reservation":_vm.reservation}}):_vm._e(),_vm._v(" "),(_vm.showLocations())?_c('Locations',{attrs:{"quoteInProgress":_vm.quoteInProgress},on:{"rideTypeUpdated":_vm.onRideTypeUpdated,"locationsSet":_vm.onLocationsSet,"locationsComplete":_vm.onLocationsComplete,"quoteInProgress":_vm.onQuoteInProgress,"quoteReceived":_vm.onQuoteReceived}}):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"quotes"}},[(_vm.showQuotes())?_c('Quote',{attrs:{"reservation":_vm.reservation},on:{"selectReservation":_vm.onQuoteSelected}}):_vm._e()],1),_vm._v(" "),(_vm.showDateTime() && _vm.rideType !== 'AIRPORTPICKUP')?_c('DateTime',{on:{"dateTimeComplete":_vm.onDateTimeComplete}}):_vm._e(),_vm._v(" "),(_vm.showDateTime() && _vm.rideType === 'AIRPORTPICKUP')?_c('FlightInfo',{on:{"meetAndGreetUpdated":_vm.onMeetAndGreetUpdated,"flightInfoComplete":_vm.onFlightInfoComplete}}):_vm._e(),_vm._v(" "),(_vm.showContactPrimary())?_c('Contact',{attrs:{"authenticated":_vm.authenticated},on:{"contactType":_vm.onContactType,"contactComplete":_vm.onContactComplete}}):_vm._e(),_vm._v(" "),(_vm.showContactSecondary())?_c('Contact',{attrs:{"passenger":""}}):_vm._e(),_vm._v(" "),(_vm.showRequest())?_c('Request',{attrs:{"reservation":_vm.reservation,"additionalLineItems":_vm.additionalLineItems},on:{"rideType":_vm.rideType,"requestUpdated":_vm.onRequestUpdate}}):_vm._e(),_vm._v(" "),(_vm.showConfirmation())?_c('Confirmation',{attrs:{"reservation":_vm.requestedReservation}}):_vm._e(),_vm._v(" "),(!_vm.confirmed)?_c('div',[_c('div',{staticClass:"ui fluid positive button reqbutton",class:{ disabled: !_vm.requestComplete || _vm.requestInProgress, visible: !_vm.confirmed, loading: _vm.requestInProgress },on:{"click":function($event){_vm.completeReservation()}}},[_vm._v("Submit Request")]),_vm._v(" "),_c('div',{staticClass:"ui fluid secondary button reqbutton",on:{"click":function($event){_vm.reset()}}},[_vm._v("Cancel and Start Over")])]):_c('div',[_c('div',{staticClass:"ui fluid primary button reqbutton",on:{"click":function($event){_vm.reset()}}},[_vm._v("Make Another Reservation")])]),_vm._v(" "),_c('div',{staticClass:"ui modal",attrs:{"id":"errorModal"}},[_c('div',{staticClass:"header"},[_vm._v("Sorry, there was a problem!")]),_vm._v(" "),_c('div',{staticClass:"content"},_vm._l((_vm.errors),function(error,index){return _c('p',{key:index},[_vm._v(_vm._s(error))])})),_vm._v(" "),_vm._m(0)])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"actions"},[_c('div',{staticClass:"ui approve button"},[_vm._v("Ok")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"home":{"errors":{"payment":"There was a problem with your payment information. Please reconfirm and try again. If you continue receiving this error, please contact Aces.","other":"There was a problem submitting your reservation. Please try again. If you continue receiving this error, please contact Aces."}}}}')
  delete Component.options._Ctor
}


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callback_vue__ = __webpack_require__(72);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c68ddd1e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callback_vue__ = __webpack_require__(184);
function injectStyle (ssrContext) {
  __webpack_require__(182)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c68ddd1e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(183);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("16308fc1", content, true, {});

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, ".spinner{position:absolute;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100vh;width:100vw;background-color:#fff;top:0;bottom:0;left:0;right:0}", ""]);

// exports


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[_c('img',{attrs:{"src":__webpack_require__(185),"alt":"loading"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reservations_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_187e835e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reservations_vue__ = __webpack_require__(189);
function injectStyle (ssrContext) {
  __webpack_require__(187)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reservations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_187e835e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reservations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(188);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("27a2c118", content, true, {});

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"ui two column table"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.reservations),function(res,index){return _c('tr',{key:index},[_vm._l((res.addresses),function(address,a_index){return (address.type === 'PICKUP')?_c('td',{key:'thing_' + a_index},[_vm._v(_vm._s(address.streetAddress)+", "+_vm._s(address.city)+", "+_vm._s(address.state)+" "+_vm._s(address.zip))]):_vm._e()}),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatFriendlyDate(res.pickupDateTime)))]),_vm._v(" "),_vm._m(1,true)],2)}))])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("Pickup")]),_vm._v(" "),_c('th',[_vm._v("Cancel")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"right aligned"},[_c('i',{staticClass:"close icon"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountCodes_vue__ = __webpack_require__(74);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3de17a7a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountCodes_vue__ = __webpack_require__(199);
function injectStyle (ssrContext) {
  __webpack_require__(191)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountCodes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3de17a7a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountCodes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(192);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("782e708b", content, true, {});

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(false);
// imports


// module
exports.push([module.i, "a{cursor:pointer}body{background-color:#fff}.ui.menu .item img.logo{margin-right:1.5em}.main.container{margin-top:7em}.wireframe{margin-top:2em}.ui.footer.segment{margin:5em 0 0;padding:5em 0}.ui.fluid.positive.button.reqbutton,.ui.fluid.primary.button.reqbutton,.ui.fluid.secondary.button.reqbutton{margin-bottom:.5em;margin-top:.5em}", ""]);

// exports


/***/ }),
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ui main text container"},[_c('div',{staticClass:"ui grid"},[_c('div',{staticClass:"sixteen column row"},[_c('div',{staticClass:"sixteen wide column"},[_c('div',{staticClass:"ui segment"},[_c('h1',{staticClass:"ui header"},[_vm._v("Account Codes")]),_vm._v(" "),_c('table',{staticClass:"ui celled table"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.accountCodes),function(accountCode,index){return _c('tr',{key:index},[_c('td',{attrs:{"data-label":"Name"}},[_vm._v(_vm._s(accountCode.name))]),_vm._v(" "),_c('td',{attrs:{"data-label":"Code"}},[_vm._v(_vm._s(accountCode.code))]),_vm._v(" "),_c('td',{attrs:{"data-label":"Status"},on:{"click":function($event){_vm.toggleCode(index)}}},[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(accountCode.status))])])])}))]),_vm._v(" "),_c('div',{staticClass:"ui action fluid input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newCodeName),expression:"newCodeName"}],attrs:{"type":"text","placeholder":"Account Name"},domProps:{"value":(_vm.newCodeName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newCodeName=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"ui green button",on:{"click":function($event){_vm.createNewCode()}}},[_vm._v("Create New Code")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Code")]),_vm._v(" "),_c('th',[_vm._v("Status")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ui inverted menu"},[_c('div',{staticClass:"ui container"},[_c('a',{staticClass:"header item",attrs:{"href":"/"}},[_vm._v("\n        Aces Town Car Service\n      ")]),_vm._v(" "),(_vm.usersEnabled())?_c('div',{staticClass:"right menu"},[(_vm.authenticated)?_c('div',{staticClass:"ui dropdown item"},[_vm._v("\n          Account\n          "),_c('i',{staticClass:"dropdown icon"}),_vm._v(" "),_c('div',{staticClass:"ui vertical menu"},[_c('a',{staticClass:"item",attrs:{"href":"/reservations"}},[_vm._v("Reservations")]),_vm._v(" "),_c('a',{staticClass:"item",on:{"click":function($event){_vm.auth.logout()}}},[_vm._v("Log Out")])])]):_vm._e(),_vm._v(" "),(!_vm.authenticated)?_c('div',{staticClass:"ui dropdown item",on:{"click":function($event){_vm.auth.login()}}},[_vm._v("\n          Login / Signup\n        ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"ui main text container"},[_c('router-view',{attrs:{"auth":_vm.auth,"authenticated":_vm.authenticated}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[75]);


// WEBPACK FOOTER //
// static/js/app.026678ff76fb0abf1ae0.js